import { Country } from '../types';

export const asiaData: Country[] = [
  {
    "code": "AF",
    "name": "Afghanistan",
    "nameAr": "أفغانستان",
    "nameFr": "Afghanistan",
    "cities": [
      {
        "name": "Badakhshan",
        "nameAr": "",
        "nameFr": "Badakhshan"
      },
      {
        "name": "Badghis",
        "nameAr": "",
        "nameFr": "Badghis"
      },
      {
        "name": "Baghlan",
        "nameAr": "",
        "nameFr": "Baghlan"
      },
      {
        "name": "Balkh",
        "nameAr": "",
        "nameFr": "Balkh"
      },
      {
        "name": "Bamyan",
        "nameAr": "",
        "nameFr": "Bamyan"
      },
      {
        "name": "Daykundi",
        "nameAr": "",
        "nameFr": "Daykundi"
      },
      {
        "name": "Farah",
        "nameAr": "",
        "nameFr": "Farah"
      },
      {
        "name": "Faryab",
        "nameAr": "",
        "nameFr": "Faryab"
      },
      {
        "name": "Ghazni",
        "nameAr": "",
        "nameFr": "Ghazni"
      },
      {
        "name": "Ghōr",
        "nameAr": "",
        "nameFr": "Ghōr"
      },
      {
        "name": "Helmand",
        "nameAr": "",
        "nameFr": "Helmand"
      },
      {
        "name": "Herat",
        "nameAr": "",
        "nameFr": "Herat"
      },
      {
        "name": "Jowzjan",
        "nameAr": "",
        "nameFr": "Jowzjan"
      },
      {
        "name": "Kabul",
        "nameAr": "",
        "nameFr": "Kabul"
      },
      {
        "name": "Kandahar",
        "nameAr": "",
        "nameFr": "Kandahar"
      },
      {
        "name": "Kapisa",
        "nameAr": "",
        "nameFr": "Kapisa"
      },
      {
        "name": "Khost",
        "nameAr": "",
        "nameFr": "Khost"
      },
      {
        "name": "Kunar",
        "nameAr": "",
        "nameFr": "Kunar"
      },
      {
        "name": "Kunduz Province",
        "nameAr": "",
        "nameFr": "Kunduz Province"
      },
      {
        "name": "Laghman",
        "nameAr": "",
        "nameFr": "Laghman"
      },
      {
        "name": "Logar",
        "nameAr": "",
        "nameFr": "Logar"
      },
      {
        "name": "Nangarhar",
        "nameAr": "",
        "nameFr": "Nangarhar"
      },
      {
        "name": "Nimruz",
        "nameAr": "",
        "nameFr": "Nimruz"
      },
      {
        "name": "Nuristan",
        "nameAr": "",
        "nameFr": "Nuristan"
      },
      {
        "name": "Paktia",
        "nameAr": "",
        "nameFr": "Paktia"
      },
      {
        "name": "Paktika",
        "nameAr": "",
        "nameFr": "Paktika"
      },
      {
        "name": "Panjshir",
        "nameAr": "",
        "nameFr": "Panjshir"
      },
      {
        "name": "Parwan",
        "nameAr": "",
        "nameFr": "Parwan"
      },
      {
        "name": "Samangan",
        "nameAr": "",
        "nameFr": "Samangan"
      },
      {
        "name": "Sar-e Pol",
        "nameAr": "",
        "nameFr": "Sar-e Pol"
      },
      {
        "name": "Takhar",
        "nameAr": "",
        "nameFr": "Takhar"
      },
      {
        "name": "Urozgan",
        "nameAr": "",
        "nameFr": "Urozgan"
      },
      {
        "name": "Zabul",
        "nameAr": "",
        "nameFr": "Zabul"
      }
    ]
  },
  {
    "code": "AQ",
    "name": "Antarctica",
    "nameAr": "Antarctica",
    "nameFr": "Antarctica",
    "cities": []
  },
  {
    "code": "AM",
    "name": "Armenia",
    "nameAr": "أرمينيا",
    "nameFr": "Armenia",
    "cities": [
      {
        "name": "Aragatsotn",
        "nameAr": "Aragatsotn",
        "nameFr": "Aragatsotn"
      },
      {
        "name": "Ararat",
        "nameAr": "أرارات",
        "nameFr": "Ararat"
      },
      {
        "name": "Tavush",
        "nameAr": "تافوش",
        "nameFr": "Tavush"
      },
      {
        "name": "Lorri",
        "nameAr": "Lorri",
        "nameFr": "Lorri"
      },
      {
        "name": "Armavir",
        "nameAr": "أرمافير",
        "nameFr": "Armavir"
      },
      {
        "name": "Yerevan",
        "nameAr": "يريفان",
        "nameFr": "Erevan"
      },
      {
        "name": "Shirak",
        "nameAr": "شيراك",
        "nameFr": "Shirak"
      }
    ]
  },
  {
    "code": "AZ",
    "name": "Azerbaijan",
    "nameAr": "أذربيجان",
    "nameFr": "Azerbaijan",
    "cities": [
      {
        "name": "Neftcala",
        "nameAr": "نيفتكالا",
        "nameFr": "Neftcala"
      },
      {
        "name": "Xanlar",
        "nameAr": "زانلار",
        "nameFr": "Xanlar"
      },
      {
        "name": "Yevlax",
        "nameAr": "يفلاكس",
        "nameFr": "Yevlax"
      },
      {
        "name": "Agdas",
        "nameAr": "أجداس",
        "nameFr": "Agdas"
      },
      {
        "name": "Sabirabad",
        "nameAr": "سابيراباد",
        "nameFr": "Sabirabad"
      },
      {
        "name": "Yardimli",
        "nameAr": "يارديملي",
        "nameFr": "Yardimli"
      },
      {
        "name": "Calilabad",
        "nameAr": "Calilabad",
        "nameFr": "Calilabad"
      },
      {
        "name": "Saatli",
        "nameAr": "ساتلي",
        "nameFr": "Saatli"
      },
      {
        "name": "Saki",
        "nameAr": "الساقي",
        "nameFr": "Saki"
      },
      {
        "name": "Kurdamir",
        "nameAr": "كوردامير",
        "nameFr": "Kurdamir"
      },
      {
        "name": "Qazax",
        "nameAr": "كازاكس",
        "nameFr": "Qazax"
      },
      {
        "name": "Tovuz",
        "nameAr": "توفوز",
        "nameFr": "Tovuz"
      },
      {
        "name": "Samkir",
        "nameAr": "سامكير",
        "nameFr": "Samkir"
      },
      {
        "name": "Agdam",
        "nameAr": "أغدام",
        "nameFr": "Agdam"
      },
      {
        "name": "Qubadli",
        "nameAr": "كوبادلي",
        "nameFr": "Qubadli"
      },
      {
        "name": "Oguz",
        "nameAr": "أوغوز",
        "nameFr": "Oguz"
      },
      {
        "name": "Lacin",
        "nameAr": "لاكين",
        "nameFr": "Lacin"
      },
      {
        "name": "Kalbacar",
        "nameAr": "كالباكار",
        "nameFr": "Kalbacar"
      },
      {
        "name": "Haciqabul",
        "nameAr": "Haciqabul",
        "nameFr": "Haciqabul"
      },
      {
        "name": "Bilasuvar",
        "nameAr": "بيلاسوفار",
        "nameFr": "Bilasuvar"
      },
      {
        "name": "Balakan",
        "nameAr": "بالاكان",
        "nameFr": "Balakan"
      },
      {
        "name": "Naxcivan",
        "nameAr": "ناخيتشيفان",
        "nameFr": "Naxcivan"
      },
      {
        "name": "Qabala",
        "nameAr": "قابالا",
        "nameFr": "Qabala"
      },
      {
        "name": "Agcabadi",
        "nameAr": "أجكابادي",
        "nameFr": "Agcabadi"
      },
      {
        "name": "Samaxi",
        "nameAr": "ساماكسي",
        "nameFr": "Samaxi"
      },
      {
        "name": "Davaci",
        "nameAr": "دافاسي",
        "nameFr": "Davaci"
      },
      {
        "name": "Quba",
        "nameAr": "قباء",
        "nameFr": "Quba"
      },
      {
        "name": "Qusar",
        "nameAr": "كوسار",
        "nameFr": "Qusar"
      },
      {
        "name": "Imisli",
        "nameAr": "إيميسلي",
        "nameFr": "Imisli"
      },
      {
        "name": "Abseron",
        "nameAr": "أبسيرون",
        "nameFr": "Abseron"
      },
      {
        "name": "Xacmaz",
        "nameAr": "زاكماز",
        "nameFr": "Xacmaz"
      },
      {
        "name": "Cabrayil",
        "nameAr": "كابرايل",
        "nameFr": "Cabrayil"
      },
      {
        "name": "Ismayilli",
        "nameAr": "إيسمييلي",
        "nameFr": "Ismayilli"
      },
      {
        "name": "Goranboy",
        "nameAr": "غورانبوي",
        "nameFr": "Goranboy"
      },
      {
        "name": "Fuzuli",
        "nameAr": "فضولي",
        "nameFr": "Fuzuli"
      },
      {
        "name": "Baki",
        "nameAr": "باكي",
        "nameFr": "Baki"
      },
      {
        "name": "Beylaqan",
        "nameAr": "بيلاكان",
        "nameFr": "Beylaqan"
      },
      {
        "name": "Daskasan",
        "nameAr": "داسكاسان",
        "nameFr": "Daskasan"
      },
      {
        "name": "Masalli",
        "nameAr": "ماسالي",
        "nameFr": "Masalli"
      },
      {
        "name": "Zaqatala",
        "nameAr": "زاكاتالا",
        "nameFr": "Zaqatala"
      },
      {
        "name": "Lankaran",
        "nameAr": "نكران",
        "nameFr": "Lankaran"
      },
      {
        "name": "Lerik",
        "nameAr": "ليريك",
        "nameFr": "Lerik"
      },
      {
        "name": "Ali Bayramli",
        "nameAr": "علي بيرملي",
        "nameFr": "Ali Bayramli"
      },
      {
        "name": "Qax",
        "nameAr": "QAX",
        "nameFr": "Qax"
      },
      {
        "name": "Samux",
        "nameAr": "ساموكس",
        "nameFr": "Samux"
      },
      {
        "name": "Zardab",
        "nameAr": "زارداب",
        "nameFr": "Zardab"
      },
      {
        "name": "Gadabay",
        "nameAr": "جاداباي",
        "nameFr": "Gadabay"
      },
      {
        "name": "Ucar",
        "nameAr": "أوكار",
        "nameFr": "Ucar"
      },
      {
        "name": "Barda",
        "nameAr": "بردا",
        "nameFr": "Barda"
      },
      {
        "name": "Siyazan",
        "nameAr": "سيازان",
        "nameFr": "Siyazan"
      },
      {
        "name": "Xocavand",
        "nameAr": "كسوكافاند",
        "nameFr": "Xocavand"
      },
      {
        "name": "Zangilan",
        "nameAr": "زانجيلان",
        "nameFr": "Zangilan"
      },
      {
        "name": "Xizi",
        "nameAr": "XIZI",
        "nameFr": "Xizi"
      },
      {
        "name": "Yevlax",
        "nameAr": "يفلاكس",
        "nameFr": "Yevlax"
      },
      {
        "name": "Agsu",
        "nameAr": "AGSU",
        "nameFr": "Agsu"
      },
      {
        "name": "Qobustan",
        "nameAr": "كوبستان",
        "nameFr": "Qobustan"
      },
      {
        "name": "Goycay",
        "nameAr": "جويكاي",
        "nameFr": "Goycay"
      },
      {
        "name": "Astara",
        "nameAr": "أستارا",
        "nameFr": "Astara"
      },
      {
        "name": "Xocali",
        "nameAr": "كسوكالي",
        "nameFr": "Xocali"
      },
      {
        "name": "Xankandi",
        "nameAr": "زانكاندي",
        "nameFr": "Xankandi"
      },
      {
        "name": "Tartar",
        "nameAr": "رواسب",
        "nameFr": "Tartre"
      },
      {
        "name": "Agstafa",
        "nameAr": "أجستافا",
        "nameFr": "Agstafa"
      },
      {
        "name": "Salyan",
        "nameAr": "ساليان",
        "nameFr": "Salyan"
      },
      {
        "name": "Susa",
        "nameAr": "سوسة",
        "nameFr": "Susa"
      },
      {
        "name": "Ganca",
        "nameAr": "غانكا",
        "nameFr": "Ganca"
      },
      {
        "name": "Sumqayit",
        "nameAr": "سامكيت",
        "nameFr": "Sumqayit"
      },
      {
        "name": "Saki",
        "nameAr": "الساقي",
        "nameFr": "Saki"
      },
      {
        "name": "Naftalan",
        "nameAr": "نفتالان",
        "nameFr": "Naftalan"
      },
      {
        "name": "Lankaran",
        "nameAr": "نكران",
        "nameFr": "Lankaran"
      },
      {
        "name": "Mingacevir",
        "nameAr": "مينغاشفير",
        "nameFr": "Mingacevir"
      },
      {
        "name": "Susa",
        "nameAr": "سوسة",
        "nameFr": "Susa"
      }
    ]
  },
  {
    "code": "BH",
    "name": "Bahrain",
    "nameAr": "البحرين",
    "nameFr": "Bahrain",
    "cities": [
            {
                  "name": "Jidd Hafs",
                  "nameAr": "جد حفص",
                  "nameFr": "Jidd Hafs"
            },
            {
                  "name": "Al Mintaqah ash Shamaliyah",
                  "nameAr": "المنطقة الشمالية",
                  "nameFr": "Al Mintaqah cendres Shamaliyah"
            },
            {
                  "name": "Al Manamah",
                  "nameAr": "المنامة",
                  "nameFr": "Al Manamah"
            },
            {
                  "name": "Sitrah",
                  "nameAr": "سترة",
                  "nameFr": "Sitrah"
            },
            {
                  "name": "Al Mintaqah al Gharbiyah",
                  "nameAr": "المنطقة الغربية",
                  "nameFr": "Al Mintaqah al Gharbiyah"
            },
            {
                  "name": "Mintaqat Juzur Hawar",
                  "nameAr": "ولاية جزرور حوار",
                  "nameFr": "Mintaqat Juzur Hawar"
            },
            {
                  "name": "Al Hadd",
                  "nameAr": "الحد",
                  "nameFr": "Al Hadd"
            },
            {
                  "name": "Al Mintaqah al Wusta",
                  "nameAr": "المنطقة الوسطى",
                  "nameFr": "Al Mintaqah al Wusta"
            },
            {
                  "name": "Ar Rifa",
                  "nameAr": "الرفاع",
                  "nameFr": "Ar Rifa"
            },
            {
                  "name": "Madinat",
                  "nameAr": "مدينة",
                  "nameFr": "Madinat"
            }
      ]
  },
  {
    "code": "BD",
    "name": "Bangladesh",
    "nameAr": "بنغلاديش",
    "nameFr": "Bangladesh",
    "cities": [
      {
        "name": "Khulna",
        "nameAr": "خولنا",
        "nameFr": "Khulna"
      },
      {
        "name": "Rajshahi",
        "nameAr": "راجشاهي",
        "nameFr": "Rajshahi"
      },
      {
        "name": "Dhaka",
        "nameAr": "دكا",
        "nameFr": "Dhaka"
      },
      {
        "name": "Barisal",
        "nameAr": "باريسال",
        "nameFr": "Barisal"
      },
      {
        "name": "Sylhet",
        "nameAr": "سيلهيت",
        "nameFr": "Sylhet"
      },
      {
        "name": "Chittagong",
        "nameAr": "شيتاغونغ",
        "nameFr": "Chittagong"
      }
    ]
  },
  {
    "code": "BT",
    "name": "Bhutan",
    "nameAr": "بوتان",
    "nameFr": "Bhutan",
    "cities": [
      {
        "name": "Wangdi Phodrang",
        "nameAr": "وانجدي Phodrang",
        "nameFr": "Wangdi Phodrang"
      },
      {
        "name": "Paro",
        "nameAr": "بارو",
        "nameFr": "Paro"
      },
      {
        "name": "Daga",
        "nameAr": "داغا",
        "nameFr": "Daga"
      },
      {
        "name": "Mongar",
        "nameAr": "مونغار",
        "nameFr": "Mongar"
      },
      {
        "name": "Shemgang",
        "nameAr": "Shemgang",
        "nameFr": "Shemgang"
      },
      {
        "name": "Thimphu",
        "nameAr": "تيمفو",
        "nameFr": "Thimphu"
      },
      {
        "name": "Tashigang",
        "nameAr": "Tashigang",
        "nameFr": "Tashigang"
      },
      {
        "name": "Chirang",
        "nameAr": "شيرانغ",
        "nameFr": "Chirang"
      },
      {
        "name": "Geylegphug",
        "nameAr": "Geylegphug",
        "nameFr": "Geylegphug"
      },
      {
        "name": "Samdrup",
        "nameAr": "سامدروب",
        "nameFr": "Samdrup"
      },
      {
        "name": "Bumthang",
        "nameAr": "بوم ثانج",
        "nameFr": "Bumthang"
      },
      {
        "name": "Samchi",
        "nameAr": "Samchi",
        "nameFr": "Samchi"
      },
      {
        "name": "Tongsa",
        "nameAr": "Tongsa",
        "nameFr": "Tongsa"
      },
      {
        "name": "Chhukha",
        "nameAr": "جوخا",
        "nameFr": "Chhukha"
      },
      {
        "name": "Pemagatsel",
        "nameAr": "Pemagatsel",
        "nameFr": "Pemagatsel"
      },
      {
        "name": "Ha",
        "nameAr": "ها",
        "nameFr": "Ha"
      },
      {
        "name": "Punakha",
        "nameAr": "بونخا",
        "nameFr": "Punakha"
      },
      {
        "name": "Lhuntshi",
        "nameAr": "Lhuntshi",
        "nameFr": "Lhuntshi"
      }
    ]
  },
  {
    "code": "BV",
    "name": "Bouvet Island",
    "nameAr": "Bouvet Island",
    "nameFr": "Bouvet Island",
    "cities": []
  },
  {
    "code": "BN",
    "name": "Brunei",
    "nameAr": "بروناي",
    "nameFr": "Brunei",
    "cities": [
            {
                  "name": "Abu Dhabi",
                  "nameAr": "أبو ظبي",
                  "nameFr": "Abu Dhabi"
            },
            {
                  "name": "Ajman",
                  "nameAr": "عجمان",
                  "nameFr": "Ajman"
            },
            {
                  "name": "Dubai",
                  "nameAr": "دبي",
                  "nameFr": "Dubai"
            },
            {
                  "name": "Fujairah",
                  "nameAr": "فجيرة",
                  "nameFr": "Fujairah"
            },
            {
                  "name": "Ras Al Khaimah",
                  "nameAr": "Ras Al Khaimah",
                  "nameFr": "Ras Al Khaimah"
            },
            {
                  "name": "Sharjah",
                  "nameAr": "الشارقة",
                  "nameFr": "Sharjah"
            },
            {
                  "name": "Umm Al Quwain",
                  "nameAr": "أم القوي",
                  "nameFr": "Umm Al Quwain"
            }
      ]
  },
  {
    "code": "KH",
    "name": "Cambodia",
    "nameAr": "كمبوديا",
    "nameFr": "Cambodia",
    "cities": [
            {
                  "name": "Banteay Meanchey",
                  "nameAr": "បន្ទាយមានជ័យ",
                  "nameFr": "Banteay Meanchey"
            },
            {
                  "name": "Battambang",
                  "nameAr": "បាត់ដំបង",
                  "nameFr": "Battambang"
            },
            {
                  "name": "Kampong Cham",
                  "nameAr": "Kampong Cham",
                  "nameFr": "Kampong Cham"
            },
            {
                  "name": "Kampong Chhnang",
                  "nameAr": "កំពង់ឆ្នាំង",
                  "nameFr": "Kampong Chhnang"
            },
            {
                  "name": "Kampong Speu",
                  "nameAr": "ភូមិសែ",
                  "nameFr": "Kampong Speu"
            },
            {
                  "name": "Kampong Thom",
                  "nameAr": "កំពង់ធំ",
                  "nameFr": "Kampong Thom"
            },
            {
                  "name": "Kampot",
                  "nameAr": "កំពត",
                  "nameFr": "Kampot"
            },
            {
                  "name": "Kandal",
                  "nameAr": "បេសបេល",
                  "nameFr": "Kandal"
            },
            {
                  "name": "Kep",
                  "nameAr": "កែប",
                  "nameFr": "Kep"
            },
            {
                  "name": "Koh Kong",
                  "nameAr": "កោះកុង",
                  "nameFr": "Koh Kong"
            },
            {
                  "name": "Kratie",
                  "nameAr": "ក្រចេះ",
                  "nameFr": "Kratie"
            },
            {
                  "name": "Mondulkiri",
                  "nameAr": "មណ្ឌលគីរី",
                  "nameFr": "Mondulkiri"
            },
            {
                  "name": "Oddar Meanchey",
                  "nameAr": "ឧត្តរមានជ័យ",
                  "nameFr": "Oddar Meanchey"
            },
            {
                  "name": "Pailin",
                  "nameAr": "លំអី",
                  "nameFr": "Pailin"
            },
            {
                  "name": "Phnom Penh",
                  "nameAr": "រាជធានី",
                  "nameFr": "Phnom Penh"
            },
            {
                  "name": "Preah Vihear",
                  "nameAr": "ព្រះវិហារ",
                  "nameFr": "Preah Vihear"
            },
            {
                  "name": "Prey Veng",
                  "nameAr": "បុរស",
                  "nameFr": "Prey Veng"
            },
            {
                  "name": "Pursat",
                  "nameAr": "ឱកាស",
                  "nameFr": "Pursat"
            },
            {
                  "name": "Ratanakiri",
                  "nameAr": "រតនគិរី",
                  "nameFr": "Ratanakiri"
            },
            {
                  "name": "Siem Reap",
                  "nameAr": "សៀមរាប",
                  "nameFr": "Siem Reap"
            },
            {
                  "name": "Sihanoukville",
                  "nameAr": "ក្រុងព្រះសីហនុ",
                  "nameFr": "Sihanoukville"
            },
            {
                  "name": "Stung Treng",
                  "nameAr": "ត្រូវការស្ទឹង",
                  "nameFr": "Stung Treng"
            },
            {
                  "name": "Svay Rieng",
                  "nameAr": "ស្វាយរៀង",
                  "nameFr": "Svay Rieng"
            },
            {
                  "name": "Takeo",
                  "nameAr": "តាកែវ",
                  "nameFr": "Takeo"
            }
      ]
  },
  {
    "code": "CN",
    "name": "China",
    "nameAr": "الصين",
    "nameFr": "China",
    "cities": [
      {
        "name": "Sichuan",
        "nameAr": "سيتشوان",
        "nameFr": "Sichuan"
      },
      {
        "name": "Xinjiang",
        "nameAr": "شينجيانغ",
        "nameFr": "Xinjiang"
      },
      {
        "name": "Nei Mongol",
        "nameAr": "ني المغول",
        "nameFr": "Nei Mongol"
      },
      {
        "name": "Yunnan",
        "nameAr": "يونان",
        "nameFr": "Yunnan"
      },
      {
        "name": "Guizhou",
        "nameAr": "قويتشو",
        "nameFr": "Guizhou"
      },
      {
        "name": "Heilongjiang",
        "nameAr": "هيلونغجيانغ",
        "nameFr": "Heilongjiang"
      },
      {
        "name": "Shandong",
        "nameAr": "شاندونغ",
        "nameFr": "Shandong"
      },
      {
        "name": "Liaoning",
        "nameAr": "لياونينغ",
        "nameFr": "Liaoning"
      },
      {
        "name": "Shaanxi",
        "nameAr": "شنشى",
        "nameFr": "Shaanxi"
      },
      {
        "name": "Qinghai",
        "nameAr": "تشينغهاي",
        "nameFr": "Qinghai"
      },
      {
        "name": "Gansu",
        "nameAr": "قانسو",
        "nameFr": "Gansu"
      },
      {
        "name": "Jiangsu",
        "nameAr": "جيانغسو",
        "nameFr": "Jiangsu"
      },
      {
        "name": "Fujian",
        "nameAr": "فوجيان",
        "nameFr": "Fujian"
      },
      {
        "name": "Hunan",
        "nameAr": "هونان",
        "nameFr": "Hunan"
      },
      {
        "name": "Jiangxi",
        "nameAr": "جيانغشى",
        "nameFr": "Jiangxi"
      },
      {
        "name": "Guangxi",
        "nameAr": "قوانغشى",
        "nameFr": "Guangxi"
      },
      {
        "name": "Zhejiang",
        "nameAr": "تشجيانغ",
        "nameFr": "Zhejiang"
      },
      {
        "name": "Hebei",
        "nameAr": "خبى",
        "nameFr": "Hebei"
      },
      {
        "name": "Hubei",
        "nameAr": "هوبى",
        "nameFr": "Hubei"
      },
      {
        "name": "Anhui",
        "nameAr": "انهوى",
        "nameFr": "Anhui"
      },
      {
        "name": "Tianjin",
        "nameAr": "تيانجين",
        "nameFr": "Tianjin"
      },
      {
        "name": "Hainan",
        "nameAr": "هاينان",
        "nameFr": "Hainan"
      },
      {
        "name": "Guangdong",
        "nameAr": "قوانغدونغ",
        "nameFr": "Guangdong"
      },
      {
        "name": "Xizang",
        "nameAr": "زيزانغ",
        "nameFr": "Xizang"
      },
      {
        "name": "Jilin",
        "nameAr": "جيلين",
        "nameFr": "Jilin"
      },
      {
        "name": "Chongqing",
        "nameAr": "تشونغتشينغ",
        "nameFr": "Chongqing"
      },
      {
        "name": "Beijing",
        "nameAr": "بكين",
        "nameFr": "Pékin"
      },
      {
        "name": "Shanxi",
        "nameAr": "شانشى",
        "nameFr": "Shanxi"
      },
      {
        "name": "Shanghai",
        "nameAr": "شنغهاي",
        "nameFr": "Shanghai"
      },
      {
        "name": "Henan",
        "nameAr": "خنان",
        "nameFr": "Henan"
      },
      {
        "name": "Ningxia",
        "nameAr": "نينغشيا",
        "nameFr": "Ningxia"
      }
    ]
  },
  {
    "code": "GE",
    "name": "Georgia",
    "nameAr": "جورجيا",
    "nameFr": "Georgia",
    "cities": [
            {
                  "name": "Bumthang ",
                  "nameAr": "Bumthang ",
                  "nameFr": "Bumthang "
            },
            {
                  "name": "Chukha ",
                  "nameAr": "Chukha ",
                  "nameFr": "Chukha "
            },
            {
                  "name": "Dagana ",
                  "nameAr": "Dagana ",
                  "nameFr": "Dagana "
            },
            {
                  "name": "Gasa ",
                  "nameAr": "Gasa ",
                  "nameFr": "Gasa "
            },
            {
                  "name": "Haa ",
                  "nameAr": "Haa ",
                  "nameFr": "Haa "
            },
            {
                  "name": "Lhuntse ",
                  "nameAr": "Lhuntse ",
                  "nameFr": "Lhuntse "
            },
            {
                  "name": "Mongar ",
                  "nameAr": "Mongar ",
                  "nameFr": "Mongar "
            },
            {
                  "name": "Paro ",
                  "nameAr": "Paro ",
                  "nameFr": "Paro "
            },
            {
                  "name": "Pemagatshel ",
                  "nameAr": "Pemagatshel ",
                  "nameFr": "Pemagatshel "
            },
            {
                  "name": "Punakha ",
                  "nameAr": "Punakha ",
                  "nameFr": "Punakha "
            },
            {
                  "name": "Samdrup Jongkhar ",
                  "nameAr": "Samdrup Jongkhar ",
                  "nameFr": "Samdrup Jongkhar "
            },
            {
                  "name": "Samtse ",
                  "nameAr": "Samtse ",
                  "nameFr": "Samtse "
            },
            {
                  "name": "Sarpang ",
                  "nameAr": "Sarpang ",
                  "nameFr": "Sarpang "
            },
            {
                  "name": "Thimphu ",
                  "nameAr": "Thimphu ",
                  "nameFr": "Thimphu "
            },
            {
                  "name": "Trashi Yangtse\t",
                  "nameAr": "Trashi Yangtse\t",
                  "nameFr": "Trashi Yangtse\t"
            },
            {
                  "name": "Trashigang ",
                  "nameAr": "Trashigang ",
                  "nameFr": "Trashigang "
            },
            {
                  "name": "Trongsa ",
                  "nameAr": "Trongsa ",
                  "nameFr": "Trongsa "
            },
            {
                  "name": "Tsirang ",
                  "nameAr": "Tsirang ",
                  "nameFr": "Tsirang "
            },
            {
                  "name": "Wangdue Phodrang ",
                  "nameAr": "Wangdue Phodrang ",
                  "nameFr": "Wangdue Phodrang "
            },
            {
                  "name": "Zhemgang ",
                  "nameAr": "Zhemgang ",
                  "nameFr": "Zhemgang "
            }
      ]
  },
  {
    "code": "HM",
    "name": "Heard Island and McDonald Islands",
    "nameAr": "Heard Island and McDonald Islands",
    "nameFr": "Heard Island and McDonald Islands",
    "cities": []
  },
  {
    "code": "HK",
    "name": "Hong Kong S.A.R.",
    "nameAr": "هونغ كونغ",
    "nameFr": "Hong Kong S.A.R.",
    "cities": [
            {
                  "name": "Central and Western",
                  "nameAr": "Central and Western",
                  "nameFr": "Central and Western"
            },
            {
                  "name": "Eastern",
                  "nameAr": "Eastern",
                  "nameFr": "Eastern"
            },
            {
                  "name": "Islands",
                  "nameAr": "Islands",
                  "nameFr": "Islands"
            },
            {
                  "name": "Kowloon City",
                  "nameAr": "Kowloon City",
                  "nameFr": "Kowloon City"
            },
            {
                  "name": "Kwai Tsing",
                  "nameAr": "Kwai Tsing",
                  "nameFr": "Kwai Tsing"
            },
            {
                  "name": "Kwun Tong",
                  "nameAr": "Kwun Tong",
                  "nameFr": "Kwun Tong"
            },
            {
                  "name": "North",
                  "nameAr": "North",
                  "nameFr": "North"
            },
            {
                  "name": "Sai Kung",
                  "nameAr": "Sai Kung",
                  "nameFr": "Sai Kung"
            },
            {
                  "name": "Sha Tin",
                  "nameAr": "Sha Tin",
                  "nameFr": "Sha Tin"
            },
            {
                  "name": "Sham Shui Po",
                  "nameAr": "Sham Shui Po",
                  "nameFr": "Sham Shui Po"
            },
            {
                  "name": "Southern",
                  "nameAr": "Southern",
                  "nameFr": "Southern"
            },
            {
                  "name": "Tai Po",
                  "nameAr": "Tai Po",
                  "nameFr": "Tai Po"
            },
            {
                  "name": "Tsuen Wan",
                  "nameAr": "Tsuen Wan",
                  "nameFr": "Tsuen Wan"
            },
            {
                  "name": "Tuen Mun",
                  "nameAr": "Tuen Mun",
                  "nameFr": "Tuen Mun"
            },
            {
                  "name": "Wan Chai",
                  "nameAr": "Wan Chai",
                  "nameFr": "Wan Chai"
            },
            {
                  "name": "Wong Tai Sin",
                  "nameAr": "Wong Tai Sin",
                  "nameFr": "Wong Tai Sin"
            },
            {
                  "name": "Yau Tsim Mong",
                  "nameAr": "Yau Tsim Mong",
                  "nameFr": "Yau Tsim Mong"
            },
            {
                  "name": "Yuen Long",
                  "nameAr": "Yuen Long",
                  "nameFr": "Yuen Long"
            }
      ]
  },
  {
    "code": "IN",
    "name": "India",
    "nameAr": "الهند",
    "nameFr": "India",
    "cities": [
            {
                  "name": "Andaman and Nicobar Islands",
                  "nameAr": "अंडमान व नोकोबार द्वीप समूह",
                  "nameFr": "Andaman and Nicobar Islands"
            },
            {
                  "name": "Andhra Pradesh",
                  "nameAr": "आंध्र प्रदेश",
                  "nameFr": "Andhra Pradesh"
            },
            {
                  "name": "Arunachal Pradesh",
                  "nameAr": "Arunachal Pradesh",
                  "nameFr": "Arunachal Pradesh"
            },
            {
                  "name": "Assam",
                  "nameAr": "असम",
                  "nameFr": "Assam"
            },
            {
                  "name": "Bihar",
                  "nameAr": "बिहार",
                  "nameFr": "Bihar"
            },
            {
                  "name": "Chandigarh",
                  "nameAr": "चंडीगढ़",
                  "nameFr": "Chandigarh"
            },
            {
                  "name": "Chhattisgarh",
                  "nameAr": "Chhattisgarh",
                  "nameFr": "Chhattisgarh"
            },
            {
                  "name": "Dadra and Nagar Haveli and Daman and Diu",
                  "nameAr": "Dadra and Nagar Haveli and Daman and Diu",
                  "nameFr": "Dadra and Nagar Haveli and Daman and Diu"
            },
            {
                  "name": "Delhi",
                  "nameAr": "दिल्ली",
                  "nameFr": "Delhi"
            },
            {
                  "name": "Goa",
                  "nameAr": "गोवा",
                  "nameFr": "Goa"
            },
            {
                  "name": "Gujarat",
                  "nameAr": "Gujarat",
                  "nameFr": "Gujarat"
            },
            {
                  "name": "Haryana",
                  "nameAr": "हरयाणा",
                  "nameFr": "Haryana"
            },
            {
                  "name": "Himachal Pradesh",
                  "nameAr": "हिमाचल प्रदेश",
                  "nameFr": "Himachal Pradesh"
            },
            {
                  "name": "Jammu and Kashmir",
                  "nameAr": "जम्मू और कश्मीर",
                  "nameFr": "Jammu and Kashmir"
            },
            {
                  "name": "Jharkhand",
                  "nameAr": "झारखंड",
                  "nameFr": "Jharkhand"
            },
            {
                  "name": "Karnataka",
                  "nameAr": "Karnataka",
                  "nameFr": "Karnataka"
            },
            {
                  "name": "Kerala",
                  "nameAr": "केरल",
                  "nameFr": "Kerala"
            },
            {
                  "name": "Ladakh",
                  "nameAr": "Ladakh",
                  "nameFr": "Ladakh"
            },
            {
                  "name": "Lakshadweep",
                  "nameAr": "लक्षद्वीप",
                  "nameFr": "Lakshadweep"
            },
            {
                  "name": "Madhya Pradesh",
                  "nameAr": "मध्य प्रदेश",
                  "nameFr": "Madhya Pradesh"
            },
            {
                  "name": "Maharashtra",
                  "nameAr": "महाराष्ट्र",
                  "nameFr": "Maharashtra"
            },
            {
                  "name": "Manipur",
                  "nameAr": "मणिपुर",
                  "nameFr": "Manipur"
            },
            {
                  "name": "Meghalaya",
                  "nameAr": "मेघालय",
                  "nameFr": "Meghalaya"
            },
            {
                  "name": "Mizoram",
                  "nameAr": "मिजोरम",
                  "nameFr": "Mizoram"
            },
            {
                  "name": "Nagaland",
                  "nameAr": "नगालैंड",
                  "nameFr": "Nagaland"
            },
            {
                  "name": "Odisha",
                  "nameAr": "ओडिशा",
                  "nameFr": "Odisha"
            },
            {
                  "name": "Puducherry",
                  "nameAr": "पुदुचेरी",
                  "nameFr": "Puducherry"
            },
            {
                  "name": "Punjab",
                  "nameAr": "पंजाब",
                  "nameFr": "Punjab"
            },
            {
                  "name": "Rajasthan",
                  "nameAr": "Rajasthan",
                  "nameFr": "Rajasthan"
            },
            {
                  "name": "Sikkim",
                  "nameAr": "Sikkim",
                  "nameFr": "Sikkim"
            },
            {
                  "name": "Tamil Nadu",
                  "nameAr": "तमिलनाडु",
                  "nameFr": "Tamil Nadu"
            },
            {
                  "name": "Telangana",
                  "nameAr": "तेलंगाना",
                  "nameFr": "Telangana"
            },
            {
                  "name": "Tripura",
                  "nameAr": "त्रिपुरा",
                  "nameFr": "Tripura"
            },
            {
                  "name": "Uttar Pradesh",
                  "nameAr": "Uttar Pradesh",
                  "nameFr": "Uttar Pradesh"
            },
            {
                  "name": "Uttarakhand",
                  "nameAr": "उत्तराखंड",
                  "nameFr": "Uttarakhand"
            },
            {
                  "name": "West Bengal",
                  "nameAr": "पश्चिम बंगाल",
                  "nameFr": "West Bengal"
            }
      ]
  },
  {
    "code": "ID",
    "name": "Indonesia",
    "nameAr": "إندونيسيا",
    "nameFr": "Indonesia",
    "cities": [
            {
                  "name": "Aceh",
                  "nameAr": "Aceh",
                  "nameFr": "Aceh"
            },
            {
                  "name": "Bali",
                  "nameAr": "Bali",
                  "nameFr": "Bali"
            },
            {
                  "name": "Banten",
                  "nameAr": "Banten",
                  "nameFr": "Banten"
            },
            {
                  "name": "Bengkulu",
                  "nameAr": "Bengkulu",
                  "nameFr": "Bengkulu"
            },
            {
                  "name": "DI Yogyakarta",
                  "nameAr": "DI Yogyakarta",
                  "nameFr": "DI Yogyakarta"
            },
            {
                  "name": "DKI Jakarta",
                  "nameAr": "DKI Jakarta",
                  "nameFr": "DKI Jakarta"
            },
            {
                  "name": "Gorontalo",
                  "nameAr": "Gorontalo",
                  "nameFr": "Gorontalo"
            },
            {
                  "name": "Jambi",
                  "nameAr": "Jambi",
                  "nameFr": "Jambi"
            },
            {
                  "name": "Jawa Barat",
                  "nameAr": "Jawa Barat",
                  "nameFr": "Jawa Barat"
            },
            {
                  "name": "Jawa Tengah",
                  "nameAr": "Jawa Tengah",
                  "nameFr": "Jawa Tengah"
            },
            {
                  "name": "Jawa Timur",
                  "nameAr": "Jawa Timur",
                  "nameFr": "Jawa Timur"
            },
            {
                  "name": "Kalimantan Barat",
                  "nameAr": "Kalimantan Barat",
                  "nameFr": "Kalimantan Barat"
            },
            {
                  "name": "Kalimantan Selatan",
                  "nameAr": "Kalimantan Selatan",
                  "nameFr": "Kalimantan Selatan"
            },
            {
                  "name": "Kalimantan Tengah",
                  "nameAr": "Kalimantan Tengah",
                  "nameFr": "Kalimantan Tengah"
            },
            {
                  "name": "Kalimantan Timur",
                  "nameAr": "Kalimantan Timur",
                  "nameFr": "Kalimantan Timur"
            },
            {
                  "name": "Kalimantan Utara",
                  "nameAr": "Kalimantan Utara",
                  "nameFr": "Kalimantan Utara"
            },
            {
                  "name": "Kepulauan Bangka Belitung",
                  "nameAr": "Kepulauan Bangka Belitung",
                  "nameFr": "Kepulauan Bangka Belitung"
            },
            {
                  "name": "Kepulauan Riau",
                  "nameAr": "Kepulauan Riau",
                  "nameFr": "Kepulauan Riau"
            },
            {
                  "name": "Lampung",
                  "nameAr": "Lampung",
                  "nameFr": "Lampung"
            },
            {
                  "name": "Maluku",
                  "nameAr": "Maluku",
                  "nameFr": "Maluku"
            },
            {
                  "name": "Maluku Utara",
                  "nameAr": "Maluku Utara",
                  "nameFr": "Maluku Utara"
            },
            {
                  "name": "Nusa Tenggara Barat",
                  "nameAr": "Nusa Tenggara Barat",
                  "nameFr": "Nusa Tenggara Barat"
            },
            {
                  "name": "Nusa Tenggara Timur",
                  "nameAr": "Nusa Tenggara Timur",
                  "nameFr": "Nusa Tenggara Timur"
            },
            {
                  "name": "Papua",
                  "nameAr": "Papua",
                  "nameFr": "Papua"
            },
            {
                  "name": "Papua Barat",
                  "nameAr": "Papua Barat",
                  "nameFr": "Papua Barat"
            },
            {
                  "name": "Papua Barat Daya",
                  "nameAr": "Papua Barat Daya",
                  "nameFr": "Papua Barat Daya"
            },
            {
                  "name": "Papua Pegunungan",
                  "nameAr": "Papua Pegunungan",
                  "nameFr": "Papua Pegunungan"
            },
            {
                  "name": "Papua Selatan",
                  "nameAr": "Papua Selatan",
                  "nameFr": "Papua Selatan"
            },
            {
                  "name": "Papua Tengah",
                  "nameAr": "Papua Tengah",
                  "nameFr": "Papua Tengah"
            },
            {
                  "name": "Riau",
                  "nameAr": "Riau",
                  "nameFr": "Riau"
            },
            {
                  "name": "Sulawesi Barat",
                  "nameAr": "Sulawesi Barat",
                  "nameFr": "Sulawesi Barat"
            },
            {
                  "name": "Sulawesi Selatan",
                  "nameAr": "Sulawesi Selatan",
                  "nameFr": "Sulawesi Selatan"
            },
            {
                  "name": "Sulawesi Tengah",
                  "nameAr": "Sulawesi Tengah",
                  "nameFr": "Sulawesi Tengah"
            },
            {
                  "name": "Sulawesi Tenggara",
                  "nameAr": "Sulawesi Tenggara",
                  "nameFr": "Sulawesi Tenggara"
            },
            {
                  "name": "Sulawesi Utara",
                  "nameAr": "Sulawesi Utara",
                  "nameFr": "Sulawesi Utara"
            },
            {
                  "name": "Sumatera Barat",
                  "nameAr": "Sumatera Barat",
                  "nameFr": "Sumatera Barat"
            },
            {
                  "name": "Sumatera Selatan",
                  "nameAr": "Sumatera Selatan",
                  "nameFr": "Sumatera Selatan"
            },
            {
                  "name": "Sumatera Utara",
                  "nameAr": "Sumatera Utara",
                  "nameFr": "Sumatera Utara"
            }
      ]
  },
  {
    "code": "IR",
    "name": "Iran",
    "nameAr": "إيران",
    "nameFr": "Iran",
    "cities": [
            {
                  "name": "Alborz",
                  "nameAr": "Alborz",
                  "nameFr": "Alborz"
            },
            {
                  "name": "Ardabil",
                  "nameAr": "Ardabil",
                  "nameFr": "Ardabil"
            },
            {
                  "name": "Bushehr",
                  "nameAr": "بوشر",
                  "nameFr": "Bushehr"
            },
            {
                  "name": "Chaharmahal and Bakhtiari",
                  "nameAr": "چاهیماهال و باختیاری",
                  "nameFr": "Chaharmahal and Bakhtiari"
            },
            {
                  "name": "East Azerbaijan",
                  "nameAr": "آذربایجان شرقی",
                  "nameFr": "East Azerbaijan"
            },
            {
                  "name": "Fars",
                  "nameAr": "دور",
                  "nameFr": "Fars"
            },
            {
                  "name": "Gilan",
                  "nameAr": "گلان",
                  "nameFr": "Gilan"
            },
            {
                  "name": "Golestan",
                  "nameAr": "گله",
                  "nameFr": "Golestan"
            },
            {
                  "name": "Hamadan",
                  "nameAr": "جبهه",
                  "nameFr": "Hamadan"
            },
            {
                  "name": "Hormozgan",
                  "nameAr": "شاخی",
                  "nameFr": "Hormozgan"
            },
            {
                  "name": "Ilam",
                  "nameAr": "Ilam",
                  "nameFr": "Ilam"
            },
            {
                  "name": "Isfahan",
                  "nameAr": "اشفاهان",
                  "nameFr": "Isfahan"
            },
            {
                  "name": "Kerman",
                  "nameAr": "کرمن",
                  "nameFr": "Kerman"
            },
            {
                  "name": "Kermanshah",
                  "nameAr": "کرمانشاه",
                  "nameFr": "Kermanshah"
            },
            {
                  "name": "Khuzestan",
                  "nameAr": "Khuzestan",
                  "nameFr": "Khuzestan"
            },
            {
                  "name": "Kohgiluyeh and Boyer-Ahmad",
                  "nameAr": "کوهگلوی و بویر-احمد",
                  "nameFr": "Kohgiluyeh and Boyer-Ahmad"
            },
            {
                  "name": "Kurdistan",
                  "nameAr": "کردستان",
                  "nameFr": "Kurdistan"
            },
            {
                  "name": "Lorestan",
                  "nameAr": "لورستان",
                  "nameFr": "Lorestan"
            },
            {
                  "name": "Markazi",
                  "nameAr": "مرکز",
                  "nameFr": "Markazi"
            },
            {
                  "name": "Mazandaran",
                  "nameAr": "مازندران",
                  "nameFr": "Mazandaran"
            },
            {
                  "name": "North Khorasan",
                  "nameAr": "خراسان شمالی",
                  "nameFr": "North Khorasan"
            },
            {
                  "name": "Qazvin",
                  "nameAr": "قزوین",
                  "nameFr": "Qazvin"
            },
            {
                  "name": "Qom",
                  "nameAr": "سعدی",
                  "nameFr": "Qom"
            },
            {
                  "name": "Razavi Khorasan",
                  "nameAr": "عیار",
                  "nameFr": "Razavi Khorasan"
            },
            {
                  "name": "Semnan",
                  "nameAr": "نیمان",
                  "nameFr": "Semnan"
            },
            {
                  "name": "Sistan and Baluchestan",
                  "nameAr": "سیستان و بلوچستان",
                  "nameFr": "Sistan and Baluchestan"
            },
            {
                  "name": "South Khorasan",
                  "nameAr": "خراسان جنوبی",
                  "nameFr": "South Khorasan"
            },
            {
                  "name": "Tehran",
                  "nameAr": "تهران",
                  "nameFr": "Tehran"
            },
            {
                  "name": "West Azarbaijan",
                  "nameAr": "West Azarbaijan",
                  "nameFr": "West Azarbaijan"
            },
            {
                  "name": "Yazd",
                  "nameAr": "Yazd",
                  "nameFr": "Yazd"
            },
            {
                  "name": "Zanjan",
                  "nameAr": "زنگ",
                  "nameFr": "Zanjan"
            }
      ]
  },
  {
    "code": "IQ",
    "name": "Iraq",
    "nameAr": "العراق",
    "nameFr": "Iraq",
    "cities": [
            {
                  "name": "Baghdad",
                  "nameAr": "بغداد",
                  "nameFr": "Bagdad"
            },
            {
                  "name": "Basra",
                  "nameAr": "البصرة",
                  "nameFr": "Bassorah"
            },
            {
                  "name": "Nineveh",
                  "nameAr": "نينوى",
                  "nameFr": "Ninive"
            },
            {
                  "name": "Al Anbar",
                  "nameAr": "الأنبار",
                  "nameFr": "Al-Anbar"
            },
            {
                  "name": "Erbil",
                  "nameAr": "أربيل",
                  "nameFr": "Erbil"
            },
            {
                  "name": "Sulaymaniyah",
                  "nameAr": "السليمانية",
                  "nameFr": "Souleimaniye"
            },
            {
                  "name": "Dohuk",
                  "nameAr": "دهوك",
                  "nameFr": "Dohuk"
            },
            {
                  "name": "Kirkuk",
                  "nameAr": "كركوك",
                  "nameFr": "Kirkouk"
            },
            {
                  "name": "Najaf",
                  "nameAr": "النجف",
                  "nameFr": "Nadjaf"
            },
            {
                  "name": "Karbala",
                  "nameAr": "كربلاء",
                  "nameFr": "Karbala"
            },
            {
                  "name": "Diyala",
                  "nameAr": "ديالى",
                  "nameFr": "Diyala"
            },
            {
                  "name": "Al-Qadisiyyah",
                  "nameAr": "القادسية",
                  "nameFr": "Al-Qadisiyyah"
            },
            {
                  "name": "Saladin",
                  "nameAr": "صلاح الدين",
                  "nameFr": "Salah ad-Din"
            },
            {
                  "name": "Babylon",
                  "nameAr": "بابل",
                  "nameFr": "Babylone"
            },
            {
                  "name": "Dhi Qar",
                  "nameAr": "ذي قار",
                  "nameFr": "Dhi Qar"
            },
            {
                  "name": "Maysan",
                  "nameAr": "ميسان",
                  "nameFr": "Maysan"
            },
            {
                  "name": "Al Muthanna",
                  "nameAr": "المثنى",
                  "nameFr": "Al-Muthanna"
            },
            {
                  "name": "Wasit",
                  "nameAr": "واسط",
                  "nameFr": "Wasit"
            }
      ]
  },
  {
    "code": "IL",
    "name": "Israel",
    "nameAr": "إسرائيل",
    "nameFr": "Israel",
    "cities": [
      {
        "name": "Central",
        "nameAr": "",
        "nameFr": "Central"
      },
      {
        "name": "Haifa",
        "nameAr": "",
        "nameFr": "Haifa"
      },
      {
        "name": "Jerusalem",
        "nameAr": "القدس",
        "nameFr": "Jerusalem"
      },
      {
        "name": "Northern",
        "nameAr": "",
        "nameFr": "Northern"
      },
      {
        "name": "Southern",
        "nameAr": "",
        "nameFr": "Southern"
      },
      {
        "name": "Tel Aviv",
        "nameAr": "",
        "nameFr": "Tel Aviv"
      }
    ]
  },
  {
    "code": "JP",
    "name": "Japan",
    "nameAr": "اليابان",
    "nameFr": "Japan",
    "cities": [
            {
                  "name": "Aichi",
                  "nameAr": "アイチ",
                  "nameFr": "Aichi"
            },
            {
                  "name": "Akita",
                  "nameAr": "秋田",
                  "nameFr": "Akita"
            },
            {
                  "name": "Aomori",
                  "nameAr": "Aomori",
                  "nameFr": "Aomori"
            },
            {
                  "name": "Chiba",
                  "nameAr": "チバ",
                  "nameFr": "Chiba"
            },
            {
                  "name": "Ehime",
                  "nameAr": "ええと",
                  "nameFr": "Ehime"
            },
            {
                  "name": "Fukui",
                  "nameAr": "Fukui",
                  "nameFr": "Fukui"
            },
            {
                  "name": "Fukuoka",
                  "nameAr": "Fukuoka",
                  "nameFr": "Fukuoka"
            },
            {
                  "name": "Fukushima",
                  "nameAr": "福島",
                  "nameFr": "Fukushima"
            },
            {
                  "name": "Gifu",
                  "nameAr": "gifu",
                  "nameFr": "Gifu"
            },
            {
                  "name": "Gunma",
                  "nameAr": "ガンマ",
                  "nameFr": "Gunma"
            },
            {
                  "name": "Hiroshima",
                  "nameAr": "広島",
                  "nameFr": "Hiroshima"
            },
            {
                  "name": "Hokkaidō",
                  "nameAr": "北海道",
                  "nameFr": "Hokkaidō"
            },
            {
                  "name": "Hyōgo",
                  "nameAr": "バンケット",
                  "nameFr": "Hyōgo"
            },
            {
                  "name": "Ibaraki",
                  "nameAr": "イバラキ",
                  "nameFr": "Ibaraki"
            },
            {
                  "name": "Ishikawa",
                  "nameAr": "石川",
                  "nameFr": "Ishikawa"
            },
            {
                  "name": "Iwate",
                  "nameAr": "iwate",
                  "nameFr": "Iwate"
            },
            {
                  "name": "Kagawa",
                  "nameAr": "Kagawa",
                  "nameFr": "Kagawa"
            },
            {
                  "name": "Kagoshima",
                  "nameAr": "Kagoshima",
                  "nameFr": "Kagoshima"
            },
            {
                  "name": "Kanagawa",
                  "nameAr": "かん川",
                  "nameFr": "Kanagawa"
            },
            {
                  "name": "Kōchi",
                  "nameAr": "Kōchi",
                  "nameFr": "Kōchi"
            },
            {
                  "name": "Kumamoto",
                  "nameAr": "kumamoto",
                  "nameFr": "Kumamoto"
            },
            {
                  "name": "Kyōto",
                  "nameAr": "Kyōto",
                  "nameFr": "Kyōto"
            },
            {
                  "name": "Mie",
                  "nameAr": "ミエ",
                  "nameFr": "Mie"
            },
            {
                  "name": "Miyagi",
                  "nameAr": "Miyagi",
                  "nameFr": "Miyagi"
            },
            {
                  "name": "Miyazaki",
                  "nameAr": "宮崎",
                  "nameFr": "Miyazaki"
            },
            {
                  "name": "Nagano",
                  "nameAr": "ナガノ",
                  "nameFr": "Nagano"
            },
            {
                  "name": "Nagasaki",
                  "nameAr": "長崎",
                  "nameFr": "Nagasaki"
            },
            {
                  "name": "Nara",
                  "nameAr": "ナラ",
                  "nameFr": "Nara"
            },
            {
                  "name": "Niigata",
                  "nameAr": "niigata",
                  "nameFr": "Niigata"
            },
            {
                  "name": "Ōita",
                  "nameAr": "爪",
                  "nameFr": "Ōita"
            },
            {
                  "name": "Okayama",
                  "nameAr": "岡山",
                  "nameFr": "Okayama"
            },
            {
                  "name": "Okinawa",
                  "nameAr": "沖縄",
                  "nameFr": "Okinawa"
            },
            {
                  "name": "Ōsaka",
                  "nameAr": "Ōsaka",
                  "nameFr": "Ōsaka"
            },
            {
                  "name": "Saga",
                  "nameAr": "サガ",
                  "nameFr": "Saga"
            },
            {
                  "name": "Saitama",
                  "nameAr": "サイタマ",
                  "nameFr": "Saitama"
            },
            {
                  "name": "Shiga",
                  "nameAr": "入力",
                  "nameFr": "Shiga"
            },
            {
                  "name": "Shimane",
                  "nameAr": "シマネ",
                  "nameFr": "Shimane"
            },
            {
                  "name": "Shizuoka",
                  "nameAr": "静岡",
                  "nameFr": "Shizuoka"
            },
            {
                  "name": "Tochigi",
                  "nameAr": "Tochigi",
                  "nameFr": "Tochigi"
            },
            {
                  "name": "Tokushima",
                  "nameAr": "徳島",
                  "nameFr": "Tokushima"
            },
            {
                  "name": "Tokyo",
                  "nameAr": "Tokyo",
                  "nameFr": "Tokyo"
            },
            {
                  "name": "Tottori",
                  "nameAr": "Tottori",
                  "nameFr": "Tottori"
            },
            {
                  "name": "Toyama",
                  "nameAr": "屋",
                  "nameFr": "Toyama"
            },
            {
                  "name": "Wakayama",
                  "nameAr": "和山",
                  "nameFr": "Wakayama"
            },
            {
                  "name": "Yamagata",
                  "nameAr": "ヤマガタ",
                  "nameFr": "Yamagata"
            },
            {
                  "name": "Yamaguchi",
                  "nameAr": "山口",
                  "nameFr": "Yamaguchi"
            },
            {
                  "name": "Yamanashi",
                  "nameAr": "山下",
                  "nameFr": "Yamanashi"
            }
      ]
  },
  {
    "code": "JO",
    "name": "Jordan",
    "nameAr": "الأردن",
    "nameFr": "Jordan",
    "cities": [
            {
                  "name": "Amman",
                  "nameAr": "عمان",
                  "nameFr": "Amman"
            },
            {
                  "name": "Irbid",
                  "nameAr": "إربد",
                  "nameFr": "Irbid"
            },
            {
                  "name": "Zarqa",
                  "nameAr": "الزرقاء",
                  "nameFr": "Zarqa"
            },
            {
                  "name": "Balqa",
                  "nameAr": "البلقاء",
                  "nameFr": "Balqa"
            },
            {
                  "name": "Madaba",
                  "nameAr": "مادبا",
                  "nameFr": "Madaba"
            },
            {
                  "name": "Karak",
                  "nameAr": "الكرك",
                  "nameFr": "Karak"
            },
            {
                  "name": "Tafilah",
                  "nameAr": "الطفيلة",
                  "nameFr": "Tafilah"
            },
            {
                  "name": "Ma'an",
                  "nameAr": "معان",
                  "nameFr": "Ma'an"
            },
            {
                  "name": "Aqaba",
                  "nameAr": "العقبة",
                  "nameFr": "Aqaba"
            },
            {
                  "name": "Jerash",
                  "nameAr": "جرش",
                  "nameFr": "Jerash"
            },
            {
                  "name": "Ajloun",
                  "nameAr": "عجلون",
                  "nameFr": "Ajloun"
            },
            {
                  "name": "Mafraq",
                  "nameAr": "المفرق",
                  "nameFr": "Mafraq"
            }
      ]
  },
  {
    "code": "KZ",
    "name": "Kazakhstan",
    "nameAr": "كازاخستان",
    "nameFr": "Kazakhstan",
    "cities": [
            {
                  "name": "Abai",
                  "nameAr": "Ааа",
                  "nameFr": "Abai"
            },
            {
                  "name": "Akmola",
                  "nameAr": "Ақмола",
                  "nameFr": "Akmola"
            },
            {
                  "name": "Aktobe",
                  "nameAr": "Ктителоб",
                  "nameFr": "Aktobe"
            },
            {
                  "name": "Almaty",
                  "nameAr": "Алматы",
                  "nameFr": "Almaty"
            },
            {
                  "name": "Almaty",
                  "nameAr": "Алматы",
                  "nameFr": "Almaty"
            },
            {
                  "name": "Astana",
                  "nameAr": "Astana",
                  "nameFr": "Astana"
            },
            {
                  "name": "Atyrau",
                  "nameAr": "Айу",
                  "nameFr": "Atyrau"
            },
            {
                  "name": "East Kazakhstan",
                  "nameAr": "Шығыс Қазақстан",
                  "nameFr": "East Kazakhstan"
            },
            {
                  "name": "Jambyl",
                  "nameAr": "Жапырақты",
                  "nameFr": "Jambyl"
            },
            {
                  "name": "Jetisu",
                  "nameAr": "ЖетСиу",
                  "nameFr": "Jetisu"
            },
            {
                  "name": "Karaganda",
                  "nameAr": "Каркандта",
                  "nameFr": "Karaganda"
            },
            {
                  "name": "Kostanay",
                  "nameAr": "Kastayay",
                  "nameFr": "Kostanay"
            },
            {
                  "name": "Kyzylorda",
                  "nameAr": "Kyzylorda",
                  "nameFr": "Kyzylorda"
            },
            {
                  "name": "Mangystau",
                  "nameAr": "Маргистау",
                  "nameFr": "Mangystau"
            },
            {
                  "name": "North Kazakhstan",
                  "nameAr": "Солтүстік Қазақстан",
                  "nameFr": "North Kazakhstan"
            },
            {
                  "name": "Pavlodar",
                  "nameAr": "Павлодар",
                  "nameFr": "Pavlodar"
            },
            {
                  "name": "Shymkent",
                  "nameAr": "Шымкент",
                  "nameFr": "Shymkent"
            },
            {
                  "name": "Turkistan",
                  "nameAr": "Түркстан",
                  "nameFr": "Turkistan"
            },
            {
                  "name": "Ulytau",
                  "nameAr": "Ұлытау",
                  "nameFr": "Ulytau"
            },
            {
                  "name": "West Kazakhstan",
                  "nameAr": "Батыс Қазақстан",
                  "nameFr": "West Kazakhstan"
            }
      ]
  },
  {
    "code": "KW",
    "name": "Kuwait",
    "nameAr": "الكويت",
    "nameFr": "Kuwait",
    "cities": [
            {
                  "name": "Al Asimah",
                  "nameAr": "العاصمة",
                  "nameFr": "Al Asimah"
            },
            {
                  "name": "Hawalli",
                  "nameAr": "حولي",
                  "nameFr": "Hawalli"
            },
            {
                  "name": "Al Farwaniyah",
                  "nameAr": "الفروانية",
                  "nameFr": "Al Farwaniyah"
            },
            {
                  "name": "Al Ahmadi",
                  "nameAr": "الأحمدي",
                  "nameFr": "Al Ahmadi"
            },
            {
                  "name": "Al Jahra",
                  "nameAr": "الجهراء",
                  "nameFr": "Al Jahra"
            },
            {
                  "name": "Mubarak Al-Kabeer",
                  "nameAr": "مبارك الكبير",
                  "nameFr": "Mubarak Al-Kabeer"
            }
      ]
  },
  {
    "code": "KG",
    "name": "Kyrgyzstan",
    "nameAr": "قيرغيزستان",
    "nameFr": "Kyrgyzstan",
    "cities": [
            {
                  "name": "Batken",
                  "nameAr": "Batken",
                  "nameFr": "Batken"
            },
            {
                  "name": "Bishkek",
                  "nameAr": "Бишкек",
                  "nameFr": "Bishkek"
            },
            {
                  "name": "Chuy",
                  "nameAr": "Чүй",
                  "nameFr": "Chuy"
            },
            {
                  "name": "Issyk-Kul",
                  "nameAr": "Ыссык Көл",
                  "nameFr": "Issyk-Kul"
            },
            {
                  "name": "Jalal-Abad",
                  "nameAr": "Жалал Абад",
                  "nameFr": "Jalal-Abad"
            },
            {
                  "name": "Naryn",
                  "nameAr": "ZEA",
                  "nameFr": "Naryn"
            },
            {
                  "name": "Osh",
                  "nameAr": "Osh",
                  "nameFr": "Osh"
            },
            {
                  "name": "Osh",
                  "nameAr": "Ош",
                  "nameFr": "Osh"
            },
            {
                  "name": "Talas",
                  "nameAr": "Сүйлөйт",
                  "nameFr": "Talas"
            }
      ]
  },
  {
    "code": "LA",
    "name": "Laos",
    "nameAr": "لاوس",
    "nameFr": "Laos",
    "cities": [
            {
                  "name": "Attapeu",
                  "nameAr": "ອັດຖະກໍາ",
                  "nameFr": "Attapeu"
            },
            {
                  "name": "Bokeo",
                  "nameAr": "ໂກດີໂຊ",
                  "nameFr": "Bokeo"
            },
            {
                  "name": "Bolikhamsai",
                  "nameAr": "Bolikhamasai",
                  "nameFr": "Bolikhamsai"
            },
            {
                  "name": "Champasak",
                  "nameAr": "ຈໍາປາສັກ",
                  "nameFr": "Champasak"
            },
            {
                  "name": "Houaphanh",
                  "nameAr": "Houaphanh",
                  "nameFr": "Houaphanh"
            },
            {
                  "name": "Khammouane",
                  "nameAr": "ຄໍາມ່ວນ",
                  "nameFr": "Khammouane"
            },
            {
                  "name": "Luang Namtha",
                  "nameAr": "ຫຼວງນ້ໍາທາ",
                  "nameFr": "Luang Namtha"
            },
            {
                  "name": "Luang Prabang",
                  "nameAr": "ຫລວງພະບາງ",
                  "nameFr": "Luang Prabang"
            },
            {
                  "name": "Oudomxay",
                  "nameAr": "Oudo",
                  "nameFr": "Oudomxay"
            },
            {
                  "name": "Phongsaly",
                  "nameAr": "ຂ່າວສານຜົ້ງສາລີ",
                  "nameFr": "Phongsaly"
            },
            {
                  "name": "Sainyabuli",
                  "nameAr": "Sailyabuli",
                  "nameFr": "Sainyabuli"
            },
            {
                  "name": "Salavan",
                  "nameAr": "ສາລະອອງ",
                  "nameFr": "Salavan"
            },
            {
                  "name": "Savannakhet",
                  "nameAr": "ສະຫວັນນະເຂດ",
                  "nameFr": "Savannakhet"
            },
            {
                  "name": "Sekong",
                  "nameAr": "ເຄີ່ງ",
                  "nameFr": "Sekong"
            },
            {
                  "name": "Vientiane",
                  "nameAr": "ວຽງຈັນ",
                  "nameFr": "Vientiane"
            },
            {
                  "name": "Vientiane",
                  "nameAr": "ວຽງຈັນ",
                  "nameFr": "Vientiane"
            },
            {
                  "name": "Xaisomboun",
                  "nameAr": "Xaishombounounounoun",
                  "nameFr": "Xaisomboun"
            },
            {
                  "name": "Xiangkhouang",
                  "nameAr": "ນະໂຍບາຍ",
                  "nameFr": "Xiangkhouang"
            }
      ]
  },
  {
    "code": "LB",
    "name": "Lebanon",
    "nameAr": "لبنان",
    "nameFr": "Lebanon",
    "cities": [
            {
                  "name": "Beirut",
                  "nameAr": "بيروت",
                  "nameFr": "Beyrouth"
            },
            {
                  "name": "Mount Lebanon",
                  "nameAr": "جبل لبنان",
                  "nameFr": "Mont-Liban"
            },
            {
                  "name": "North",
                  "nameAr": "الشمال",
                  "nameFr": "Nord"
            },
            {
                  "name": "South",
                  "nameAr": "الجنوب",
                  "nameFr": "Sud"
            },
            {
                  "name": "Beqaa",
                  "nameAr": "البقاع",
                  "nameFr": "Bekaa"
            },
            {
                  "name": "Nabatieh",
                  "nameAr": "النبطية",
                  "nameFr": "Nabatieh"
            },
            {
                  "name": "Akkar",
                  "nameAr": "عكار",
                  "nameFr": "Akkar"
            },
            {
                  "name": "Baalbek-Hermel",
                  "nameAr": "بعلبك-الهرمل",
                  "nameFr": "Baalbek-Hermel"
            }
      ]
  },
  {
    "code": "MO",
    "name": "Macau S.A.R.",
    "nameAr": "ماكاو",
    "nameFr": "Macau S.A.R.",
    "cities": []
  },
  {
    "code": "MY",
    "name": "Malaysia",
    "nameAr": "ماليزيا",
    "nameFr": "Malaysia",
    "cities": [
            {
                  "name": "Johor",
                  "nameAr": "Johor",
                  "nameFr": "Johor"
            },
            {
                  "name": "Kedah",
                  "nameAr": "Kedah",
                  "nameFr": "Kedah"
            },
            {
                  "name": "Kelantan",
                  "nameAr": "Kelantan",
                  "nameFr": "Kelantan"
            },
            {
                  "name": "Kuala Lumpur",
                  "nameAr": "Kuala Lumpur",
                  "nameFr": "Kuala Lumpur"
            },
            {
                  "name": "Labuan",
                  "nameAr": "Labuan",
                  "nameFr": "Labuan"
            },
            {
                  "name": "Malacca",
                  "nameAr": "Melaka",
                  "nameFr": "Malacca"
            },
            {
                  "name": "Negeri Sembilan",
                  "nameAr": "Negeri Sembilan",
                  "nameFr": "Negeri Sembilan"
            },
            {
                  "name": "Pahang",
                  "nameAr": "Pahang",
                  "nameFr": "Pahang"
            },
            {
                  "name": "Penang",
                  "nameAr": "Pulau Pinang",
                  "nameFr": "Penang"
            },
            {
                  "name": "Perak",
                  "nameAr": "Perak",
                  "nameFr": "Perak"
            },
            {
                  "name": "Perlis",
                  "nameAr": "Perlis",
                  "nameFr": "Perlis"
            },
            {
                  "name": "Putrajaya",
                  "nameAr": "Putrajaya",
                  "nameFr": "Putrajaya"
            },
            {
                  "name": "Sabah",
                  "nameAr": "Sabah",
                  "nameFr": "Sabah"
            },
            {
                  "name": "Sarawak",
                  "nameAr": "Sarawak",
                  "nameFr": "Sarawak"
            },
            {
                  "name": "Selangor",
                  "nameAr": "Selangor",
                  "nameFr": "Selangor"
            },
            {
                  "name": "Terengganu",
                  "nameAr": "Terengganu",
                  "nameFr": "Terengganu"
            }
      ]
  },
  {
    "code": "MV",
    "name": "Maldives",
    "nameAr": "جزر المالديف",
    "nameFr": "Maldives",
    "cities": [
            {
                  "name": "Addu",
                  "nameAr": "ދުޢާ",
                  "nameFr": "Addu"
            },
            {
                  "name": "Alif Alif",
                  "nameAr": "އަލީފް އަލީފް",
                  "nameFr": "Alif Alif"
            },
            {
                  "name": "Alif Dhaal",
                  "nameAr": "އަލީފް ދަލް",
                  "nameFr": "Alif Dhaal"
            },
            {
                  "name": "Central",
                  "nameAr": "ސެންޓްރަލް",
                  "nameFr": "Central"
            },
            {
                  "name": "Dhaalu",
                  "nameAr": "ދައުލޫ",
                  "nameFr": "Dhaalu"
            },
            {
                  "name": "Faafu",
                  "nameAr": "ފައު",
                  "nameFr": "Faafu"
            },
            {
                  "name": "Gaafu Alif",
                  "nameAr": "އެ ސުވާލު އަލިފް",
                  "nameFr": "Gaafu Alif"
            },
            {
                  "name": "Gaafu Dhaalu",
                  "nameAr": "އެމީހުންނަށް ވާރުތަވާ ސުވާލު",
                  "nameFr": "Gaafu Dhaalu"
            },
            {
                  "name": "Gnaviyani",
                  "nameAr": "ގްނާވިއަން",
                  "nameFr": "Gnaviyani"
            },
            {
                  "name": "Haa Alif",
                  "nameAr": "ހާ އަލިފް",
                  "nameFr": "Haa Alif"
            },
            {
                  "name": "Haa Dhaalu",
                  "nameAr": "އޭނާއަށް ވާރުތަވާށިއެވެ .",
                  "nameFr": "Haa Dhaalu"
            },
            {
                  "name": "Kaafu",
                  "nameAr": "ކައިފީ",
                  "nameFr": "Kaafu"
            },
            {
                  "name": "Laamu",
                  "nameAr": "ސަރުކާރު",
                  "nameFr": "Laamu"
            },
            {
                  "name": "Lhaviyani",
                  "nameAr": "ލަހަވާނީ",
                  "nameFr": "Lhaviyani"
            },
            {
                  "name": "Malé",
                  "nameAr": "ކުޑަ",
                  "nameFr": "Malé"
            },
            {
                  "name": "Meemu",
                  "nameAr": "މީމު",
                  "nameFr": "Meemu"
            },
            {
                  "name": "Noonu",
                  "nameAr": "އަޅުގަނޑުމެންގެ USU .",
                  "nameFr": "Noonu"
            },
            {
                  "name": "North Central",
                  "nameAr": "ނޯތު ސެންޓްރަލް",
                  "nameFr": "North Central"
            },
            {
                  "name": "Raa",
                  "nameAr": "ރާ",
                  "nameFr": "Raa"
            },
            {
                  "name": "Shaviyani",
                  "nameAr": "ލޮނު",
                  "nameFr": "Shaviyani"
            },
            {
                  "name": "South",
                  "nameAr": "ދެކުނު",
                  "nameFr": "South"
            },
            {
                  "name": "South Central",
                  "nameAr": "ސައުތު ސެންޓްރަލް",
                  "nameFr": "South Central"
            },
            {
                  "name": "Thaa",
                  "nameAr": "ތައާ",
                  "nameFr": "Thaa"
            },
            {
                  "name": "Upper South",
                  "nameAr": "މަތީ ދެކުނު",
                  "nameFr": "Upper South"
            },
            {
                  "name": "Vaavu",
                  "nameAr": "ހެދުން",
                  "nameFr": "Vaavu"
            }
      ]
  },
  {
    "code": "MN",
    "name": "Mongolia",
    "nameAr": "منغوليا",
    "nameFr": "Mongolia",
    "cities": [
            {
                  "name": "Arkhangai",
                  "nameAr": "Аркхангай",
                  "nameFr": "Arkhangai"
            },
            {
                  "name": "Bayan-Ölgii",
                  "nameAr": "Of-olgii",
                  "nameFr": "Bayan-Ölgii"
            },
            {
                  "name": "Bayankhongor",
                  "nameAr": "Bayankhryr",
                  "nameFr": "Bayankhongor"
            },
            {
                  "name": "Bulgan",
                  "nameAr": "Сүйрэл",
                  "nameFr": "Bulgan"
            },
            {
                  "name": "Darkhan-Uul",
                  "nameAr": "Darkhan-uul",
                  "nameFr": "Darkhan-Uul"
            },
            {
                  "name": "Dornod",
                  "nameAr": "Тэнэгдой",
                  "nameFr": "Dornod"
            },
            {
                  "name": "Dornogovi",
                  "nameAr": "Dornogovi",
                  "nameFr": "Dornogovi"
            },
            {
                  "name": "Dundgovi",
                  "nameAr": "Dundgovi",
                  "nameFr": "Dundgovi"
            },
            {
                  "name": "Govi-Altai",
                  "nameAr": "Гови-Алтай",
                  "nameFr": "Govi-Altai"
            },
            {
                  "name": "Govisümber",
                  "nameAr": "Гово",
                  "nameFr": "Govisümber"
            },
            {
                  "name": "Khentii",
                  "nameAr": "Хекенти",
                  "nameFr": "Khentii"
            },
            {
                  "name": "Khovd",
                  "nameAr": "Барааны агуулах",
                  "nameFr": "Khovd"
            },
            {
                  "name": "Khövsgöl",
                  "nameAr": "Khövsgöl",
                  "nameFr": "Khövsgöl"
            },
            {
                  "name": "Ömnögovi",
                  "nameAr": "ÖMNögovi",
                  "nameFr": "Ömnögovi"
            },
            {
                  "name": "Orkhon",
                  "nameAr": "Orkhon",
                  "nameFr": "Orkhon"
            },
            {
                  "name": "Övörkhangai",
                  "nameAr": "Хормой",
                  "nameFr": "Övörkhangai"
            },
            {
                  "name": "Selenge",
                  "nameAr": "Дэлж",
                  "nameFr": "Selenge"
            },
            {
                  "name": "Sükhbaatar",
                  "nameAr": "Сүкбаатар",
                  "nameFr": "Sükhbaatar"
            },
            {
                  "name": "Töv",
                  "nameAr": "Буурсан",
                  "nameFr": "Töv"
            },
            {
                  "name": "Ulaanbaatar",
                  "nameAr": "Ulaanbaatar",
                  "nameFr": "Ulaanbaatar"
            },
            {
                  "name": "Uvs",
                  "nameAr": "Ums",
                  "nameFr": "Uvs"
            },
            {
                  "name": "Zavkhan",
                  "nameAr": "Zavkhan",
                  "nameFr": "Zavkhan"
            }
      ]
  },
  {
    "code": "MM",
    "name": "Myanmar",
    "nameAr": "ميانمار",
    "nameFr": "Myanmar",
    "cities": [
            {
                  "name": "Ayeyarwady",
                  "nameAr": "ar ရာဝတီ",
                  "nameFr": "Ayeyarwady"
            },
            {
                  "name": "Bago",
                  "nameAr": "ဉီးစွာ",
                  "nameFr": "Bago"
            },
            {
                  "name": "Chin",
                  "nameAr": "မေးစေ့",
                  "nameFr": "Chin"
            },
            {
                  "name": "Kachin",
                  "nameAr": "ကချင်လူမျိုး",
                  "nameFr": "Kachin"
            },
            {
                  "name": "Kayah",
                  "nameAr": "ကရင်",
                  "nameFr": "Kayah"
            },
            {
                  "name": "Kayin",
                  "nameAr": "nephy",
                  "nameFr": "Kayin"
            },
            {
                  "name": "Magway",
                  "nameAr": "ဆောင်ရွက်နိုင်",
                  "nameFr": "Magway"
            },
            {
                  "name": "Mandalay",
                  "nameAr": "မန္တလေး",
                  "nameFr": "Mandalay"
            },
            {
                  "name": "Mon State",
                  "nameAr": "မွန်ပြည်နယ်",
                  "nameFr": "Mon State"
            },
            {
                  "name": "Naypyidaw",
                  "nameAr": "နေပြည်တော်",
                  "nameFr": "Naypyidaw"
            },
            {
                  "name": "Rakhine",
                  "nameAr": "ရခိုင်",
                  "nameFr": "Rakhine"
            },
            {
                  "name": "Sagaing",
                  "nameAr": "စစ်ကိုင်းတိုင်း",
                  "nameFr": "Sagaing"
            },
            {
                  "name": "Shan",
                  "nameAr": "ရှမ်း",
                  "nameFr": "Shan"
            },
            {
                  "name": "Tanintharyi",
                  "nameAr": "တနင်္သာရီ",
                  "nameFr": "Tanintharyi"
            },
            {
                  "name": "Yangon",
                  "nameAr": "ရန်ကုန်",
                  "nameFr": "Yangon"
            }
      ]
  },
  {
    "code": "NP",
    "name": "Nepal",
    "nameAr": "نيبال",
    "nameFr": "Nepal",
    "cities": [
            {
                  "name": "Bagmati",
                  "nameAr": "बागमती",
                  "nameFr": "Bagmati"
            },
            {
                  "name": "Gandaki",
                  "nameAr": "गेन्की",
                  "nameFr": "Gandaki"
            },
            {
                  "name": "Karnali",
                  "nameAr": "मोटरगाडी",
                  "nameFr": "Karnali"
            },
            {
                  "name": "Koshi",
                  "nameAr": "वा उसलाई",
                  "nameFr": "Koshi"
            },
            {
                  "name": "Lumbini",
                  "nameAr": "लुम्बिनी",
                  "nameFr": "Lumbini"
            },
            {
                  "name": "Madhesh",
                  "nameAr": "मधेश",
                  "nameFr": "Madhesh"
            },
            {
                  "name": "Sudurpashchim",
                  "nameAr": "सुदर्गेपचिम",
                  "nameFr": "Sudurpashchim"
            }
      ]
  },
  {
    "code": "KP",
    "name": "North Korea",
    "nameAr": "كوريا الشمالية",
    "nameFr": "North Korea",
    "cities": [
            {
                  "name": "Chagang",
                  "nameAr": "Chagang",
                  "nameFr": "Chagang"
            },
            {
                  "name": "Kangwon",
                  "nameAr": "kangwon",
                  "nameFr": "Kangwon"
            },
            {
                  "name": "North Hamgyong",
                  "nameAr": "노스 햄학",
                  "nameFr": "North Hamgyong"
            },
            {
                  "name": "North Hwanghae",
                  "nameAr": "North Hwanghae",
                  "nameFr": "North Hwanghae"
            },
            {
                  "name": "North Pyongan",
                  "nameAr": "북한",
                  "nameFr": "North Pyongan"
            },
            {
                  "name": "Pyongyang",
                  "nameAr": "Pyongyang",
                  "nameFr": "Pyongyang"
            },
            {
                  "name": "Rason",
                  "nameAr": "이유",
                  "nameFr": "Rason"
            },
            {
                  "name": "Ryanggang",
                  "nameAr": "Ryangang",
                  "nameFr": "Ryanggang"
            },
            {
                  "name": "South Hamgyong",
                  "nameAr": "사우스 햄학",
                  "nameFr": "South Hamgyong"
            },
            {
                  "name": "South Hwanghae",
                  "nameAr": "South Hwanghae",
                  "nameFr": "South Hwanghae"
            },
            {
                  "name": "South Pyongan",
                  "nameAr": "남쪽 평온",
                  "nameFr": "South Pyongan"
            }
      ]
  },
  {
    "code": "OM",
    "name": "Oman",
    "nameAr": "سلطنة عُمان",
    "nameFr": "Oman",
    "cities": [
            {
                  "name": "Muscat",
                  "nameAr": "مسقط",
                  "nameFr": "Mascate"
            },
            {
                  "name": "Dhofar",
                  "nameAr": "ظفار",
                  "nameFr": "Dhofar"
            },
            {
                  "name": "Musandam",
                  "nameAr": "مسندم",
                  "nameFr": "Musandam"
            },
            {
                  "name": "Al Buraimi",
                  "nameAr": "البريمي",
                  "nameFr": "Al Buraimi"
            },
            {
                  "name": "Ad Dakhiliyah",
                  "nameAr": "الداخلية",
                  "nameFr": "Ad Dakhiliyah"
            },
            {
                  "name": "Al Batinah North",
                  "nameAr": "شمال الباطنة",
                  "nameFr": "Al Batinah Nord"
            },
            {
                  "name": "Al Batinah South",
                  "nameAr": "جنوب الباطنة",
                  "nameFr": "Al Batinah Sud"
            },
            {
                  "name": "Ash Sharqiyah North",
                  "nameAr": "شمال الشرقية",
                  "nameFr": "Ash Sharqiyah Nord"
            },
            {
                  "name": "Ash Sharqiyah South",
                  "nameAr": "جنوب الشرقية",
                  "nameFr": "Ash Sharqiyah Sud"
            },
            {
                  "name": "Ad Dhahirah",
                  "nameAr": "الظاهرة",
                  "nameFr": "Ad Dhahirah"
            },
            {
                  "name": "Al Wusta",
                  "nameAr": "الوسطى",
                  "nameFr": "Al Wusta"
            }
      ]
  },
  {
    "code": "PK",
    "name": "Pakistan",
    "nameAr": "باكستان",
    "nameFr": "Pakistan",
    "cities": [
            {
                  "name": "Azad Kashmir",
                  "nameAr": "آزاد کشمیر",
                  "nameFr": "Azad Kashmir"
            },
            {
                  "name": "Balochistan",
                  "nameAr": "بلوچستان",
                  "nameFr": "Balochistan"
            },
            {
                  "name": "Federally Administered Tribal Areas",
                  "nameAr": "وفاقی طور پر زیر انتظام قبائلی علاقوں",
                  "nameFr": "Federally Administered Tribal Areas"
            },
            {
                  "name": "Gilgit-Baltistan",
                  "nameAr": "گلگٹ بلتستان",
                  "nameFr": "Gilgit-Baltistan"
            },
            {
                  "name": "Islamabad",
                  "nameAr": "Islamabad",
                  "nameFr": "Islamabad"
            },
            {
                  "name": "Khyber Pakhtunkhwa",
                  "nameAr": "خیبر پختوننہوا",
                  "nameFr": "Khyber Pakhtunkhwa"
            },
            {
                  "name": "Punjab",
                  "nameAr": "پنجاب",
                  "nameFr": "Punjab"
            },
            {
                  "name": "Sindh",
                  "nameAr": "سندھ",
                  "nameFr": "Sindh"
            }
      ]
  },
  {
    "code": "PS",
    "name": "Palestinian Territory Occupied",
    "nameAr": "فلسطين",
    "nameFr": "Palestinian Territory Occupied",
    "cities": [
            {
                  "name": "Bethlehem",
                  "nameAr": "بيت لحم",
                  "nameFr": "Bethlehem"
            },
            {
                  "name": "Deir El Balah",
                  "nameAr": "Deir El Balah",
                  "nameFr": "Deir El Balah"
            },
            {
                  "name": "Gaza",
                  "nameAr": "Gaza",
                  "nameFr": "Gaza"
            },
            {
                  "name": "Hebron",
                  "nameAr": "الخليل",
                  "nameFr": "Hebron"
            },
            {
                  "name": "Jenin",
                  "nameAr": "جينين",
                  "nameFr": "Jenin"
            },
            {
                  "name": "Jericho ",
                  "nameAr": "أريحا",
                  "nameFr": "Jericho "
            },
            {
                  "name": "Jerusalem (Quds)",
                  "nameAr": "القدس (القدس)",
                  "nameFr": "Jerusalem (Quds)"
            },
            {
                  "name": "Khan Yunis",
                  "nameAr": "Khan Yunis",
                  "nameFr": "Khan Yunis"
            },
            {
                  "name": "Nablus",
                  "nameAr": "نابلوس",
                  "nameFr": "Nablus"
            },
            {
                  "name": "North Gaza",
                  "nameAr": "شمال غزة",
                  "nameFr": "North Gaza"
            },
            {
                  "name": "Qalqilya",
                  "nameAr": "تلة",
                  "nameFr": "Qalqilya"
            },
            {
                  "name": "Rafah",
                  "nameAr": "رفه",
                  "nameFr": "Rafah"
            },
            {
                  "name": "Ramallah",
                  "nameAr": "رام الله",
                  "nameFr": "Ramallah"
            },
            {
                  "name": "Salfit",
                  "nameAr": "salfit",
                  "nameFr": "Salfit"
            },
            {
                  "name": "Tubas",
                  "nameAr": "توباس",
                  "nameFr": "Tubas"
            },
            {
                  "name": "Tulkarm",
                  "nameAr": "تولكرم",
                  "nameFr": "Tulkarm"
            }
      ]
  },
  {
    "code": "PH",
    "name": "Philippines",
    "nameAr": "الفلبين",
    "nameFr": "Philippines",
    "cities": [
            {
                  "name": "Abra",
                  "nameAr": "Abra",
                  "nameFr": "Abra"
            },
            {
                  "name": "Agusan del Norte",
                  "nameAr": "Agusan del Norte",
                  "nameFr": "Agusan del Norte"
            },
            {
                  "name": "Agusan del Sur",
                  "nameAr": "Agusan del Sur",
                  "nameFr": "Agusan del Sur"
            },
            {
                  "name": "Aklan",
                  "nameAr": "Aklan",
                  "nameFr": "Aklan"
            },
            {
                  "name": "Albay",
                  "nameAr": "Albay",
                  "nameFr": "Albay"
            },
            {
                  "name": "Antique",
                  "nameAr": "Antique",
                  "nameFr": "Antique"
            },
            {
                  "name": "Apayao",
                  "nameAr": "Apayao",
                  "nameFr": "Apayao"
            },
            {
                  "name": "Aurora",
                  "nameAr": "Aurora",
                  "nameFr": "Aurora"
            },
            {
                  "name": "Autonomous Region in Muslim Mindanao",
                  "nameAr": "Autonomous Region in Muslim Mindanao",
                  "nameFr": "Autonomous Region in Muslim Mindanao"
            },
            {
                  "name": "Basilan",
                  "nameAr": "Basilan",
                  "nameFr": "Basilan"
            },
            {
                  "name": "Bataan",
                  "nameAr": "Bataan",
                  "nameFr": "Bataan"
            },
            {
                  "name": "Batanes",
                  "nameAr": "Batanes",
                  "nameFr": "Batanes"
            },
            {
                  "name": "Batangas",
                  "nameAr": "Batangas",
                  "nameFr": "Batangas"
            },
            {
                  "name": "Benguet",
                  "nameAr": "Benguet",
                  "nameFr": "Benguet"
            },
            {
                  "name": "Bicol",
                  "nameAr": "Bicol",
                  "nameFr": "Bicol"
            },
            {
                  "name": "Biliran",
                  "nameAr": "Biliran",
                  "nameFr": "Biliran"
            },
            {
                  "name": "Bohol",
                  "nameAr": "Bohol",
                  "nameFr": "Bohol"
            },
            {
                  "name": "Bukidnon",
                  "nameAr": "Bukidnon",
                  "nameFr": "Bukidnon"
            },
            {
                  "name": "Bulacan",
                  "nameAr": "Bulacan",
                  "nameFr": "Bulacan"
            },
            {
                  "name": "Cagayan",
                  "nameAr": "Cagayan",
                  "nameFr": "Cagayan"
            },
            {
                  "name": "Cagayan Valley",
                  "nameAr": "Cagayan Valley",
                  "nameFr": "Cagayan Valley"
            },
            {
                  "name": "Calabarzon",
                  "nameAr": "CALABARZON",
                  "nameFr": "Calabarzon"
            },
            {
                  "name": "Camarines Norte",
                  "nameAr": "Camarines Norte",
                  "nameFr": "Camarines Norte"
            },
            {
                  "name": "Camarines Sur",
                  "nameAr": "Camarines on",
                  "nameFr": "Camarines Sur"
            },
            {
                  "name": "Camiguin",
                  "nameAr": "Camiguin",
                  "nameFr": "Camiguin"
            },
            {
                  "name": "Capiz",
                  "nameAr": "Capiz",
                  "nameFr": "Capiz"
            },
            {
                  "name": "Caraga",
                  "nameAr": "Caraga",
                  "nameFr": "Caraga"
            },
            {
                  "name": "Catanduanes",
                  "nameAr": "Catanduanes",
                  "nameFr": "Catanduanes"
            },
            {
                  "name": "Cavite",
                  "nameAr": "Cavite",
                  "nameFr": "Cavite"
            },
            {
                  "name": "Cebu",
                  "nameAr": "Cebu",
                  "nameFr": "Cebu"
            },
            {
                  "name": "Central Luzon",
                  "nameAr": "Central Luzon",
                  "nameFr": "Central Luzon"
            },
            {
                  "name": "Central Visayas",
                  "nameAr": "Central Visayas",
                  "nameFr": "Central Visayas"
            },
            {
                  "name": "Cordillera Administrative",
                  "nameAr": "Cordillera Administrative",
                  "nameFr": "Cordillera Administrative"
            },
            {
                  "name": "Cotabato",
                  "nameAr": "Cotabato",
                  "nameFr": "Cotabato"
            },
            {
                  "name": "Davao",
                  "nameAr": "Davao",
                  "nameFr": "Davao"
            },
            {
                  "name": "Davao de Oro",
                  "nameAr": "Davao de Oro",
                  "nameFr": "Davao de Oro"
            },
            {
                  "name": "Davao del Norte",
                  "nameAr": "Davao del Norte",
                  "nameFr": "Davao del Norte"
            },
            {
                  "name": "Davao del Sur",
                  "nameAr": "South Davao",
                  "nameFr": "Davao del Sur"
            },
            {
                  "name": "Davao Occidental",
                  "nameAr": "Davao Occidental",
                  "nameFr": "Davao Occidental"
            },
            {
                  "name": "Davao Oriental",
                  "nameAr": "Davao Oriental",
                  "nameFr": "Davao Oriental"
            },
            {
                  "name": "Dinagat Islands",
                  "nameAr": "Dinagat Islands",
                  "nameFr": "Dinagat Islands"
            },
            {
                  "name": "Eastern Samar",
                  "nameAr": "Eastern Samar",
                  "nameFr": "Eastern Samar"
            },
            {
                  "name": "Eastern Visayas",
                  "nameAr": "Eastern Visayas",
                  "nameFr": "Eastern Visayas"
            },
            {
                  "name": "Guimaras",
                  "nameAr": "Guimaras",
                  "nameFr": "Guimaras"
            },
            {
                  "name": "Ifugao",
                  "nameAr": "Ifugao",
                  "nameFr": "Ifugao"
            },
            {
                  "name": "Ilocos",
                  "nameAr": "Ilocos",
                  "nameFr": "Ilocos"
            },
            {
                  "name": "Ilocos Norte",
                  "nameAr": "Ilocos Norte",
                  "nameFr": "Ilocos Norte"
            },
            {
                  "name": "Ilocos Sur",
                  "nameAr": "Ilocos Sur Ilocos Sur",
                  "nameFr": "Ilocos Sur"
            },
            {
                  "name": "Iloilo",
                  "nameAr": "Iloilo",
                  "nameFr": "Iloilo"
            },
            {
                  "name": "Isabela",
                  "nameAr": "Isabela",
                  "nameFr": "Isabela"
            },
            {
                  "name": "Kalinga",
                  "nameAr": "Kalinga",
                  "nameFr": "Kalinga"
            },
            {
                  "name": "La Union",
                  "nameAr": "Union",
                  "nameFr": "La Union"
            },
            {
                  "name": "Laguna",
                  "nameAr": "Laguna",
                  "nameFr": "Laguna"
            },
            {
                  "name": "Lanao del Norte",
                  "nameAr": "Lanao del Norte",
                  "nameFr": "Lanao del Norte"
            },
            {
                  "name": "Lanao del Sur",
                  "nameAr": "Lanao of the South",
                  "nameFr": "Lanao del Sur"
            },
            {
                  "name": "Leyte",
                  "nameAr": "Leyte",
                  "nameFr": "Leyte"
            },
            {
                  "name": "Maguindanao del Norte",
                  "nameAr": "Maguindanao del Norte",
                  "nameFr": "Maguindanao del Norte"
            },
            {
                  "name": "Maguindanao del Sur",
                  "nameAr": "South.",
                  "nameFr": "Maguindanao del Sur"
            },
            {
                  "name": "Marinduque",
                  "nameAr": "Marinduque",
                  "nameFr": "Marinduque"
            },
            {
                  "name": "Masbate",
                  "nameAr": "Masbate",
                  "nameFr": "Masbate"
            },
            {
                  "name": "Mimaropa",
                  "nameAr": "MIMAROPA",
                  "nameFr": "Mimaropa"
            },
            {
                  "name": "Misamis Occidental",
                  "nameAr": "Misamis Occidental",
                  "nameFr": "Misamis Occidental"
            },
            {
                  "name": "Misamis Oriental",
                  "nameAr": "Eastern Misamis",
                  "nameFr": "Misamis Oriental"
            },
            {
                  "name": "Mountain Province",
                  "nameAr": "Mountain Province",
                  "nameFr": "Mountain Province"
            },
            {
                  "name": "National Capital Region (Metro Manila)",
                  "nameAr": "National Capital Region (Metro Manila)",
                  "nameFr": "National Capital Region (Metro Manila)"
            },
            {
                  "name": "Negros Occidental",
                  "nameAr": "Western blacks",
                  "nameFr": "Negros Occidental"
            },
            {
                  "name": "Negros Oriental",
                  "nameAr": "Eastern blacks",
                  "nameFr": "Negros Oriental"
            },
            {
                  "name": "Northern Mindanao",
                  "nameAr": "Northern Mindanao",
                  "nameFr": "Northern Mindanao"
            },
            {
                  "name": "Northern Samar",
                  "nameAr": "Northern Samar",
                  "nameFr": "Northern Samar"
            },
            {
                  "name": "Nueva Ecija",
                  "nameAr": "New Ecija",
                  "nameFr": "Nueva Ecija"
            },
            {
                  "name": "Nueva Vizcaya",
                  "nameAr": "New Biscay",
                  "nameFr": "Nueva Vizcaya"
            },
            {
                  "name": "Occidental Mindoro",
                  "nameAr": "Occidental Mindoro",
                  "nameFr": "Occidental Mindoro"
            },
            {
                  "name": "Oriental Mindoro",
                  "nameAr": "Oriental Mindoro",
                  "nameFr": "Oriental Mindoro"
            },
            {
                  "name": "Palawan",
                  "nameAr": "Palawan",
                  "nameFr": "Palawan"
            },
            {
                  "name": "Pampanga",
                  "nameAr": "Pampanga",
                  "nameFr": "Pampanga"
            },
            {
                  "name": "Pangasinan",
                  "nameAr": "Pangasinan",
                  "nameFr": "Pangasinan"
            },
            {
                  "name": "Quezon",
                  "nameAr": "Quezon",
                  "nameFr": "Quezon"
            },
            {
                  "name": "Quirino",
                  "nameAr": "Quirino",
                  "nameFr": "Quirino"
            },
            {
                  "name": "Rizal",
                  "nameAr": "Rizal",
                  "nameFr": "Rizal"
            },
            {
                  "name": "Romblon",
                  "nameAr": "Romblon",
                  "nameFr": "Romblon"
            },
            {
                  "name": "Sarangani",
                  "nameAr": "Sarangani",
                  "nameFr": "Sarangani"
            },
            {
                  "name": "Siquijor",
                  "nameAr": "Siquijor",
                  "nameFr": "Siquijor"
            },
            {
                  "name": "Soccsksargen",
                  "nameAr": "Soccsksargen",
                  "nameFr": "Soccsksargen"
            },
            {
                  "name": "Sorsogon",
                  "nameAr": "Sorsogon",
                  "nameFr": "Sorsogon"
            },
            {
                  "name": "South Cotabato",
                  "nameAr": "South Cotabato",
                  "nameFr": "South Cotabato"
            },
            {
                  "name": "Southern Leyte",
                  "nameAr": "Southern Leyte",
                  "nameFr": "Southern Leyte"
            },
            {
                  "name": "Sultan Kudarat",
                  "nameAr": "Sultan Kudarat",
                  "nameFr": "Sultan Kudarat"
            },
            {
                  "name": "Sulu",
                  "nameAr": "Sulu",
                  "nameFr": "Sulu"
            },
            {
                  "name": "Surigao del Norte",
                  "nameAr": "Surigao del Norte",
                  "nameFr": "Surigao del Norte"
            },
            {
                  "name": "Surigao del Sur",
                  "nameAr": "Surigao del Sur",
                  "nameFr": "Surigao del Sur"
            },
            {
                  "name": "Tarlac",
                  "nameAr": "Tarlac",
                  "nameFr": "Tarlac"
            },
            {
                  "name": "Tawi-Tawi",
                  "nameAr": "Tawi-tawi",
                  "nameFr": "Tawi-Tawi"
            },
            {
                  "name": "Western Samar",
                  "nameAr": "Western Samar",
                  "nameFr": "Western Samar"
            },
            {
                  "name": "Western Visayas",
                  "nameAr": "Western Visayas",
                  "nameFr": "Western Visayas"
            },
            {
                  "name": "Zambales",
                  "nameAr": "Zambales",
                  "nameFr": "Zambales"
            },
            {
                  "name": "Zamboanga del Norte",
                  "nameAr": "North Zamboanga",
                  "nameFr": "Zamboanga del Norte"
            },
            {
                  "name": "Zamboanga del Sur",
                  "nameAr": "South Zamboanga",
                  "nameFr": "Zamboanga del Sur"
            },
            {
                  "name": "Zamboanga Peninsula",
                  "nameAr": "Zamboanga Peninsula",
                  "nameFr": "Zamboanga Peninsula"
            },
            {
                  "name": "Zamboanga Sibugay",
                  "nameAr": "Zamboanga Sibugay",
                  "nameFr": "Zamboanga Sibugay"
            }
      ]
  },
  {
    "code": "QA",
    "name": "Qatar",
    "nameAr": "قطر",
    "nameFr": "Qatar",
    "cities": [
            {
                  "name": "Doha",
                  "nameAr": "الدوحة",
                  "nameFr": "Doha"
            },
            {
                  "name": "Al Rayyan",
                  "nameAr": "الريان",
                  "nameFr": "Al Rayyan"
            },
            {
                  "name": "Al Wakrah",
                  "nameAr": "الوكرة",
                  "nameFr": "Al Wakrah"
            },
            {
                  "name": "Al Khor",
                  "nameAr": "الخور",
                  "nameFr": "Al Khor"
            },
            {
                  "name": "Al Daayen",
                  "nameAr": "الضعاين",
                  "nameFr": "Al Daayen"
            },
            {
                  "name": "Al Shahaniya",
                  "nameAr": "الشحانية",
                  "nameFr": "Al Shahaniya"
            },
            {
                  "name": "Umm Salal",
                  "nameAr": "أم صلال",
                  "nameFr": "Umm Salal"
            },
            {
                  "name": "Madinat ash Shamal",
                  "nameAr": "الشمال",
                  "nameFr": "Madinat ash Shamal"
            }
      ]
  },
  {
    "code": "SA",
    "name": "Saudi Arabia",
    "nameAr": "المملكة العربية السعودية",
    "nameFr": "Saudi Arabia",
    "cities": [
            {
                  "name": "Riyadh",
                  "nameAr": "الرياض",
                  "nameFr": "Riyad"
            },
            {
                  "name": "Makkah",
                  "nameAr": "مكة المكرمة",
                  "nameFr": "La Mecque"
            },
            {
                  "name": "Madinah",
                  "nameAr": "المدينة المنورة",
                  "nameFr": "Médine"
            },
            {
                  "name": "Eastern Province",
                  "nameAr": "المنطقة الشرقية",
                  "nameFr": "Province de l'Est"
            },
            {
                  "name": "Asir",
                  "nameAr": "عسير",
                  "nameFr": "Asir"
            },
            {
                  "name": "Tabuk",
                  "nameAr": "تبوك",
                  "nameFr": "Tabouk"
            },
            {
                  "name": "Qassim",
                  "nameAr": "القصيم",
                  "nameFr": "Qassim"
            },
            {
                  "name": "Hail",
                  "nameAr": "حائل",
                  "nameFr": "Hail"
            },
            {
                  "name": "Northern Borders",
                  "nameAr": "الحدود الشمالية",
                  "nameFr": "Frontières du Nord"
            },
            {
                  "name": "Jazan",
                  "nameAr": "جازان",
                  "nameFr": "Jazan"
            },
            {
                  "name": "Najran",
                  "nameAr": "نجران",
                  "nameFr": "Najran"
            },
            {
                  "name": "Al-Bahah",
                  "nameAr": "الباحة",
                  "nameFr": "Al-Bahah"
            },
            {
                  "name": "Al-Jawf",
                  "nameAr": "الجوف",
                  "nameFr": "Al-Jawf"
            }
      ]
  },
  {
    "code": "SG",
    "name": "Singapore",
    "nameAr": "سنغافورة",
    "nameFr": "Singapore",
    "cities": [
            {
                  "name": "'Asir",
                  "nameAr": "الأسير",
                  "nameFr": "'Asir"
            },
            {
                  "name": "Al Bahah",
                  "nameAr": "إلى باهاه",
                  "nameFr": "Al Bahah"
            },
            {
                  "name": "Al Jawf",
                  "nameAr": "إلى Jawf",
                  "nameFr": "Al Jawf"
            },
            {
                  "name": "Al Madinah",
                  "nameAr": "Al Madinah",
                  "nameFr": "Al Madinah"
            },
            {
                  "name": "Al-Qassim",
                  "nameAr": "الفانسيوم",
                  "nameFr": "Al-Qassim"
            },
            {
                  "name": "Eastern Province",
                  "nameAr": "المقاطعة الشرقية",
                  "nameFr": "Eastern Province"
            },
            {
                  "name": "Ha'il",
                  "nameAr": "Ha'il",
                  "nameFr": "Ha'il"
            },
            {
                  "name": "Jizan",
                  "nameAr": "Jizan",
                  "nameFr": "Jizan"
            },
            {
                  "name": "Makkah",
                  "nameAr": "مكة",
                  "nameFr": "Makkah"
            },
            {
                  "name": "Najran",
                  "nameAr": "نجران",
                  "nameFr": "Najran"
            },
            {
                  "name": "Northern Borders",
                  "nameAr": "الحدود الشمالية",
                  "nameFr": "Northern Borders"
            },
            {
                  "name": "Riyadh",
                  "nameAr": "الرياض",
                  "nameFr": "Riyadh"
            },
            {
                  "name": "Tabuk",
                  "nameAr": "Tabuk",
                  "nameFr": "Tabuk"
            }
      ]
  },
  {
    "code": "KR",
    "name": "South Korea",
    "nameAr": "كوريا الجنوبية",
    "nameFr": "South Korea",
    "cities": [
            {
                  "name": "Busan",
                  "nameAr": "부산",
                  "nameFr": "Busan"
            },
            {
                  "name": "Daegu",
                  "nameAr": "대구",
                  "nameFr": "Daegu"
            },
            {
                  "name": "Daejeon",
                  "nameAr": "대전",
                  "nameFr": "Daejeon"
            },
            {
                  "name": "Gangwon",
                  "nameAr": "강원",
                  "nameFr": "Gangwon"
            },
            {
                  "name": "Gwangju",
                  "nameAr": "광주",
                  "nameFr": "Gwangju"
            },
            {
                  "name": "Gyeonggi",
                  "nameAr": "Gyeonggi",
                  "nameFr": "Gyeonggi"
            },
            {
                  "name": "Incheon",
                  "nameAr": "Incheon",
                  "nameFr": "Incheon"
            },
            {
                  "name": "Jeju",
                  "nameAr": "제주",
                  "nameFr": "Jeju"
            },
            {
                  "name": "North Chungcheong",
                  "nameAr": "노스 정찰",
                  "nameFr": "North Chungcheong"
            },
            {
                  "name": "North Gyeongsang",
                  "nameAr": "북경 산",
                  "nameFr": "North Gyeongsang"
            },
            {
                  "name": "North Jeolla",
                  "nameAr": "노스 여울",
                  "nameFr": "North Jeolla"
            },
            {
                  "name": "Sejong City",
                  "nameAr": "세종 시티",
                  "nameFr": "Sejong City"
            },
            {
                  "name": "Seoul",
                  "nameAr": "Seoul",
                  "nameFr": "Seoul"
            },
            {
                  "name": "South Chungcheong",
                  "nameAr": "South Chungcheong",
                  "nameFr": "South Chungcheong"
            },
            {
                  "name": "South Gyeongsang",
                  "nameAr": "사우스 경잔",
                  "nameFr": "South Gyeongsang"
            },
            {
                  "name": "South Jeolla",
                  "nameAr": "사우스 여질",
                  "nameFr": "South Jeolla"
            },
            {
                  "name": "Ulsan",
                  "nameAr": "울산",
                  "nameFr": "Ulsan"
            }
      ]
  },
  {
    "code": "LK",
    "name": "Sri Lanka",
    "nameAr": "سريلانكا",
    "nameFr": "Sri Lanka",
    "cities": [
            {
                  "name": "Ampara",
                  "nameAr": "සශ්රීක",
                  "nameFr": "Ampara"
            },
            {
                  "name": "Anuradhapura",
                  "nameAr": "Anuradhapura",
                  "nameFr": "Anuradhapura"
            },
            {
                  "name": "Badulla",
                  "nameAr": "බදුල්ලා",
                  "nameFr": "Badulla"
            },
            {
                  "name": "Batticaloa",
                  "nameAr": "Batticaloa",
                  "nameFr": "Batticaloa"
            },
            {
                  "name": "Central",
                  "nameAr": "Central",
                  "nameFr": "Central"
            },
            {
                  "name": "Colombo",
                  "nameAr": "කොළඹ",
                  "nameFr": "Colombo"
            },
            {
                  "name": "Eastern",
                  "nameAr": "නැගෙනහිර",
                  "nameFr": "Eastern"
            },
            {
                  "name": "Galle",
                  "nameAr": "ගාල්ල",
                  "nameFr": "Galle"
            },
            {
                  "name": "Gampaha",
                  "nameAr": "ගම්පහා",
                  "nameFr": "Gampaha"
            },
            {
                  "name": "Hambantota",
                  "nameAr": "හැමමුනටටා",
                  "nameFr": "Hambantota"
            },
            {
                  "name": "Jaffna",
                  "nameAr": "ජැෆ්ෆා",
                  "nameFr": "Jaffna"
            },
            {
                  "name": "Kalutara",
                  "nameAr": "කළුතර",
                  "nameFr": "Kalutara"
            },
            {
                  "name": "Kandy",
                  "nameAr": "මහනුවර",
                  "nameFr": "Kandy"
            },
            {
                  "name": "Kegalle",
                  "nameAr": "කෙගල්ලේ",
                  "nameFr": "Kegalle"
            },
            {
                  "name": "Kilinochchi",
                  "nameAr": "කර්නොච්චි",
                  "nameFr": "Kilinochchi"
            },
            {
                  "name": "Kurunegala",
                  "nameAr": "ජනපදනල්",
                  "nameFr": "Kurunegala"
            },
            {
                  "name": "Mannar",
                  "nameAr": "මන්නාරම",
                  "nameFr": "Mannar"
            },
            {
                  "name": "Matale",
                  "nameAr": "මෙට්ට",
                  "nameFr": "Matale"
            },
            {
                  "name": "Matara",
                  "nameAr": "විවෘත",
                  "nameFr": "Matara"
            },
            {
                  "name": "Monaragala",
                  "nameAr": "Monaragala",
                  "nameFr": "Monaragala"
            },
            {
                  "name": "Mullaitivu",
                  "nameAr": "මුල්ලයිටිව්",
                  "nameFr": "Mullaitivu"
            },
            {
                  "name": "North Central",
                  "nameAr": "උතුරු මැද",
                  "nameFr": "North Central"
            },
            {
                  "name": "North Western",
                  "nameAr": "වයඹ බටහිර",
                  "nameFr": "North Western"
            },
            {
                  "name": "Northern",
                  "nameAr": "උතුරේ",
                  "nameFr": "Northern"
            },
            {
                  "name": "Nuwara Eliya",
                  "nameAr": "එය ජෝෂාගේ වල් ය",
                  "nameFr": "Nuwara Eliya"
            },
            {
                  "name": "Polonnaruwa",
                  "nameAr": "පොලොන්නරුව",
                  "nameFr": "Polonnaruwa"
            },
            {
                  "name": "Puttalam",
                  "nameAr": "Puttalam",
                  "nameFr": "Puttalam"
            },
            {
                  "name": "Ratnapura",
                  "nameAr": "රත්නපුර",
                  "nameFr": "Ratnapura"
            },
            {
                  "name": "Sabaragamuwa",
                  "nameAr": "සපානාගමුව",
                  "nameFr": "Sabaragamuwa"
            },
            {
                  "name": "Southern",
                  "nameAr": "දක්ෂිණ",
                  "nameFr": "Southern"
            },
            {
                  "name": "Trincomalee",
                  "nameAr": "ත්රිකුණාමලය",
                  "nameFr": "Trincomalee"
            },
            {
                  "name": "Uva",
                  "nameAr": "Va ව",
                  "nameFr": "Uva"
            },
            {
                  "name": "Vavuniya",
                  "nameAr": "වවුනියා",
                  "nameFr": "Vavuniya"
            },
            {
                  "name": "Western",
                  "nameAr": "Western",
                  "nameFr": "Western"
            }
      ]
  },
  {
    "code": "SY",
    "name": "Syria",
    "nameAr": "سوريا",
    "nameFr": "Syria",
    "cities": [
            {
                  "name": "Damascus",
                  "nameAr": "دمشق",
                  "nameFr": "Damas"
            },
            {
                  "name": "Aleppo",
                  "nameAr": "حلب",
                  "nameFr": "Alep"
            },
            {
                  "name": "Homs",
                  "nameAr": "حمص",
                  "nameFr": "Homs"
            },
            {
                  "name": "Hama",
                  "nameAr": "حماة",
                  "nameFr": "Hama"
            },
            {
                  "name": "Latakia",
                  "nameAr": "اللاذقية",
                  "nameFr": "Lattaquié"
            },
            {
                  "name": "Tartus",
                  "nameAr": "طرطوس",
                  "nameFr": "Tartous"
            },
            {
                  "name": "Idlib",
                  "nameAr": "إدلب",
                  "nameFr": "Idleb"
            },
            {
                  "name": "Daraa",
                  "nameAr": "درعا",
                  "nameFr": "Deraa"
            },
            {
                  "name": "Deir ez-Zor",
                  "nameAr": "دير الزور",
                  "nameFr": "Deir ez-Zor"
            },
            {
                  "name": "Al-Hasakah",
                  "nameAr": "الحسكة",
                  "nameFr": "Al-Hasakah"
            },
            {
                  "name": "Al-Raqqah",
                  "nameAr": "الرقة",
                  "nameFr": "Ar-Raqqa"
            },
            {
                  "name": "As-Suwayda",
                  "nameAr": "السويداء",
                  "nameFr": "As-Soueida"
            },
            {
                  "name": "Quneitra",
                  "nameAr": "القنيطرة",
                  "nameFr": "Qouneitra"
            },
            {
                  "name": "Rif Dimashq",
                  "nameAr": "ريف دمشق",
                  "nameFr": "Rif Dimashq"
            }
      ]
  },
  {
    "code": "TW",
    "name": "Taiwan",
    "nameAr": "تايوان",
    "nameFr": "Taiwan",
    "cities": [
            {
                  "name": "Changhua",
                  "nameAr": "Changhua",
                  "nameFr": "Changhua"
            },
            {
                  "name": "Chiayi",
                  "nameAr": "Chiayi",
                  "nameFr": "Chiayi"
            },
            {
                  "name": "Chiayi",
                  "nameAr": "Chiayi",
                  "nameFr": "Chiayi"
            },
            {
                  "name": "Hsinchu",
                  "nameAr": "Hsinchu",
                  "nameFr": "Hsinchu"
            },
            {
                  "name": "Hsinchu",
                  "nameAr": "Hsinchu",
                  "nameFr": "Hsinchu"
            },
            {
                  "name": "Hualien",
                  "nameAr": "Hualien",
                  "nameFr": "Hualien"
            },
            {
                  "name": "Kaohsiung",
                  "nameAr": "Kaohsiung",
                  "nameFr": "Kaohsiung"
            },
            {
                  "name": "Keelung",
                  "nameAr": "Keelung",
                  "nameFr": "Keelung"
            },
            {
                  "name": "Kinmen",
                  "nameAr": "Kinmen",
                  "nameFr": "Kinmen"
            },
            {
                  "name": "Lienchiang",
                  "nameAr": "Lienchiang",
                  "nameFr": "Lienchiang"
            },
            {
                  "name": "Miaoli",
                  "nameAr": "Miaoli",
                  "nameFr": "Miaoli"
            },
            {
                  "name": "Nantou",
                  "nameAr": "Nantou",
                  "nameFr": "Nantou"
            },
            {
                  "name": "New Taipei",
                  "nameAr": "New Taipei",
                  "nameFr": "New Taipei"
            },
            {
                  "name": "Penghu",
                  "nameAr": "Penghu",
                  "nameFr": "Penghu"
            },
            {
                  "name": "Pingtung",
                  "nameAr": "Pingtung",
                  "nameFr": "Pingtung"
            },
            {
                  "name": "Taichung",
                  "nameAr": "Taichung",
                  "nameFr": "Taichung"
            },
            {
                  "name": "Tainan",
                  "nameAr": "Tainan",
                  "nameFr": "Tainan"
            },
            {
                  "name": "Taipei",
                  "nameAr": "Taipei",
                  "nameFr": "Taipei"
            },
            {
                  "name": "Taitung",
                  "nameAr": "Taitung",
                  "nameFr": "Taitung"
            },
            {
                  "name": "Taoyuan",
                  "nameAr": "Taoyuan",
                  "nameFr": "Taoyuan"
            },
            {
                  "name": "Yilan",
                  "nameAr": "Yilan",
                  "nameFr": "Yilan"
            },
            {
                  "name": "Yunlin",
                  "nameAr": "Yunlin",
                  "nameFr": "Yunlin"
            }
      ]
  },
  {
    "code": "TJ",
    "name": "Tajikistan",
    "nameAr": "طاجيكستان",
    "nameFr": "Tajikistan",
    "cities": [
            {
                  "name": "Gorno-Badakhshan",
                  "nameAr": "Вилаҳмо-Бадахшон",
                  "nameFr": "Gorno-Badakhshan"
            },
            {
                  "name": "Khatlon",
                  "nameAr": "Вилоят",
                  "nameFr": "Khatlon"
            },
            {
                  "name": "Nohiyahoi Tobei Jumhurí ",
                  "nameAr": "Nohiyahoi Tobei Jumhurí ",
                  "nameFr": "Nohiyahoi Tobei Jumhurí "
            },
            {
                  "name": "Sughd ",
                  "nameAr": "Суғд",
                  "nameFr": "Sughd "
            }
      ]
  },
  {
    "code": "TH",
    "name": "Thailand",
    "nameAr": "تايلاند",
    "nameFr": "Thailand",
    "cities": [
            {
                  "name": "Amnat Charoen",
                  "nameAr": "Amnat Charoen",
                  "nameFr": "Amnat Charoen"
            },
            {
                  "name": "Ang Thong",
                  "nameAr": "อ่างทอง",
                  "nameFr": "Ang Thong"
            },
            {
                  "name": "Bangkok",
                  "nameAr": "กรุงเทพฯ",
                  "nameFr": "Bangkok"
            },
            {
                  "name": "Bueng Kan",
                  "nameAr": "Bueng Kan",
                  "nameFr": "Bueng Kan"
            },
            {
                  "name": "Buri Ram",
                  "nameAr": "บุรีรัมย์",
                  "nameFr": "Buri Ram"
            },
            {
                  "name": "Chachoengsao",
                  "nameAr": "chachoengsao",
                  "nameFr": "Chachoengsao"
            },
            {
                  "name": "Chai Nat",
                  "nameAr": "นัท",
                  "nameFr": "Chai Nat"
            },
            {
                  "name": "Chaiyaphum",
                  "nameAr": "ชัยภูมิ",
                  "nameFr": "Chaiyaphum"
            },
            {
                  "name": "Chanthaburi",
                  "nameAr": "จันทบุรี",
                  "nameFr": "Chanthaburi"
            },
            {
                  "name": "Chiang Mai",
                  "nameAr": "เชียงใหม่",
                  "nameFr": "Chiang Mai"
            },
            {
                  "name": "Chiang Rai",
                  "nameAr": "เชียงราย",
                  "nameFr": "Chiang Rai"
            },
            {
                  "name": "Chon Buri",
                  "nameAr": "ชลบุรี",
                  "nameFr": "Chon Buri"
            },
            {
                  "name": "Chumphon",
                  "nameAr": "Chumphon",
                  "nameFr": "Chumphon"
            },
            {
                  "name": "Kalasin",
                  "nameAr": "ระวัง",
                  "nameFr": "Kalasin"
            },
            {
                  "name": "Kamphaeng Phet",
                  "nameAr": "กำแพงเพชร",
                  "nameFr": "Kamphaeng Phet"
            },
            {
                  "name": "Kanchanaburi",
                  "nameAr": "กาญจนบุรี",
                  "nameFr": "Kanchanaburi"
            },
            {
                  "name": "Khon Kaen",
                  "nameAr": "ขอนแก่น",
                  "nameFr": "Khon Kaen"
            },
            {
                  "name": "Krabi",
                  "nameAr": "Krabi",
                  "nameFr": "Krabi"
            },
            {
                  "name": "Lampang",
                  "nameAr": "พิมพ์",
                  "nameFr": "Lampang"
            },
            {
                  "name": "Lamphun",
                  "nameAr": "ลำพูน",
                  "nameFr": "Lamphun"
            },
            {
                  "name": "Loei",
                  "nameAr": "กระซิบ",
                  "nameFr": "Loei"
            },
            {
                  "name": "Lop Buri",
                  "nameAr": "ลพบุรี",
                  "nameFr": "Lop Buri"
            },
            {
                  "name": "Mae Hong Son",
                  "nameAr": "แม่ฮ่องสอน",
                  "nameFr": "Mae Hong Son"
            },
            {
                  "name": "Maha Sarakham",
                  "nameAr": "Maha Sarakham",
                  "nameFr": "Maha Sarakham"
            },
            {
                  "name": "Mukdahan",
                  "nameAr": "มุกดาหาร",
                  "nameFr": "Mukdahan"
            },
            {
                  "name": "Nakhon Nayok",
                  "nameAr": "นครนายก",
                  "nameFr": "Nakhon Nayok"
            },
            {
                  "name": "Nakhon Pathom",
                  "nameAr": "Nakhon Pathom",
                  "nameFr": "Nakhon Pathom"
            },
            {
                  "name": "Nakhon Phanom",
                  "nameAr": "นครพนม",
                  "nameFr": "Nakhon Phanom"
            },
            {
                  "name": "Nakhon Ratchasima",
                  "nameAr": "Nakhon Ratchasima",
                  "nameFr": "Nakhon Ratchasima"
            },
            {
                  "name": "Nakhon Sawan",
                  "nameAr": "นครสวรรค์",
                  "nameFr": "Nakhon Sawan"
            },
            {
                  "name": "Nakhon Si Thammarat",
                  "nameAr": "Nakhon Si thammarat",
                  "nameFr": "Nakhon Si Thammarat"
            },
            {
                  "name": "Nan",
                  "nameAr": "เข้าไปข้างใน",
                  "nameFr": "Nan"
            },
            {
                  "name": "Narathiwat",
                  "nameAr": "นราธิวาส",
                  "nameFr": "Narathiwat"
            },
            {
                  "name": "Nong Bua Lam Phu",
                  "nameAr": "Nong Bua Lam Phu",
                  "nameFr": "Nong Bua Lam Phu"
            },
            {
                  "name": "Nong Khai",
                  "nameAr": "Nong Khai",
                  "nameFr": "Nong Khai"
            },
            {
                  "name": "Nonthaburi",
                  "nameAr": "นนทบุรี",
                  "nameFr": "Nonthaburi"
            },
            {
                  "name": "Pathum Thani",
                  "nameAr": "ปทุมธานี",
                  "nameFr": "Pathum Thani"
            },
            {
                  "name": "Pattani",
                  "nameAr": "ปัตตานี",
                  "nameFr": "Pattani"
            },
            {
                  "name": "Pattaya",
                  "nameAr": "พัทยา",
                  "nameFr": "Pattaya"
            },
            {
                  "name": "Phangnga",
                  "nameAr": "Phangnga",
                  "nameFr": "Phangnga"
            },
            {
                  "name": "Phatthalung",
                  "nameAr": "พัทลุง",
                  "nameFr": "Phatthalung"
            },
            {
                  "name": "Phayao",
                  "nameAr": "Phayao",
                  "nameFr": "Phayao"
            },
            {
                  "name": "Phetchabun",
                  "nameAr": "phetchairun",
                  "nameFr": "Phetchabun"
            },
            {
                  "name": "Phetchaburi",
                  "nameAr": "เพรสบูริ",
                  "nameFr": "Phetchaburi"
            },
            {
                  "name": "Phichit",
                  "nameAr": "พิจิตร",
                  "nameFr": "Phichit"
            },
            {
                  "name": "Phitsanulok",
                  "nameAr": "พิษณุโลก",
                  "nameFr": "Phitsanulok"
            },
            {
                  "name": "Phra Nakhon Si Ayutthaya",
                  "nameAr": "พรานาคฮอนศรีอายัตทายา",
                  "nameFr": "Phra Nakhon Si Ayutthaya"
            },
            {
                  "name": "Phrae",
                  "nameAr": "พลา",
                  "nameFr": "Phrae"
            },
            {
                  "name": "Phuket",
                  "nameAr": "ภูเก็ต",
                  "nameFr": "Phuket"
            },
            {
                  "name": "Prachin Buri",
                  "nameAr": "ปราจีนบุรี",
                  "nameFr": "Prachin Buri"
            },
            {
                  "name": "Prachuap Khiri Khan",
                  "nameAr": "ประจวบคีรีขันธ์",
                  "nameFr": "Prachuap Khiri Khan"
            },
            {
                  "name": "Ranong",
                  "nameAr": "ระนอง",
                  "nameFr": "Ranong"
            },
            {
                  "name": "Ratchaburi",
                  "nameAr": "ราชบุรี",
                  "nameFr": "Ratchaburi"
            },
            {
                  "name": "Rayong",
                  "nameAr": "ระยอง",
                  "nameFr": "Rayong"
            },
            {
                  "name": "Roi Et",
                  "nameAr": "ราชาและ",
                  "nameFr": "Roi Et"
            },
            {
                  "name": "Sa Kaeo",
                  "nameAr": "Sauoo",
                  "nameFr": "Sa Kaeo"
            },
            {
                  "name": "Sakon Nakhon",
                  "nameAr": "สกลนคร",
                  "nameFr": "Sakon Nakhon"
            },
            {
                  "name": "Samut Prakan",
                  "nameAr": "Samut Prakan",
                  "nameFr": "Samut Prakan"
            },
            {
                  "name": "Samut Sakhon",
                  "nameAr": "สมุทรสาคร",
                  "nameFr": "Samut Sakhon"
            },
            {
                  "name": "Samut Songkhram",
                  "nameAr": "ดินเดียวกัน",
                  "nameFr": "Samut Songkhram"
            },
            {
                  "name": "Saraburi",
                  "nameAr": "สระบุรี",
                  "nameFr": "Saraburi"
            },
            {
                  "name": "Satun",
                  "nameAr": "ฉันเข้าไป",
                  "nameFr": "Satun"
            },
            {
                  "name": "Si Sa Ket",
                  "nameAr": "ศรีสะเกษ",
                  "nameFr": "Si Sa Ket"
            },
            {
                  "name": "Sing Buri",
                  "nameAr": "สิงห์บุรี",
                  "nameFr": "Sing Buri"
            },
            {
                  "name": "Songkhla",
                  "nameAr": "สงขลา",
                  "nameFr": "Songkhla"
            },
            {
                  "name": "Sukhothai",
                  "nameAr": "สุโขทัย",
                  "nameFr": "Sukhothai"
            },
            {
                  "name": "Suphan Buri",
                  "nameAr": "สุพรรณบุรี",
                  "nameFr": "Suphan Buri"
            },
            {
                  "name": "Surat Thani",
                  "nameAr": "สุราษฎร์ธานี",
                  "nameFr": "Surat Thani"
            },
            {
                  "name": "Surin",
                  "nameAr": "การรู้สึกเสียวซ่า",
                  "nameFr": "Surin"
            },
            {
                  "name": "Tak",
                  "nameAr": "ไม่",
                  "nameFr": "Tak"
            },
            {
                  "name": "Trang",
                  "nameAr": "หน้าหนังสือ",
                  "nameFr": "Trang"
            },
            {
                  "name": "Trat",
                  "nameAr": "ที่ถูกเตะ",
                  "nameFr": "Trat"
            },
            {
                  "name": "Ubon Ratchathani",
                  "nameAr": "อุบลราชธานี",
                  "nameFr": "Ubon Ratchathani"
            },
            {
                  "name": "Udon Thani",
                  "nameAr": "อุดรธานี",
                  "nameFr": "Udon Thani"
            },
            {
                  "name": "Uthai Thani",
                  "nameAr": "อุทัยธานี",
                  "nameFr": "Uthai Thani"
            },
            {
                  "name": "Uttaradit",
                  "nameAr": "อุตรดิตถ์",
                  "nameFr": "Uttaradit"
            },
            {
                  "name": "Yala",
                  "nameAr": "ยะลา",
                  "nameFr": "Yala"
            },
            {
                  "name": "Yasothon",
                  "nameAr": "ยโสธร",
                  "nameFr": "Yasothon"
            }
      ]
  },
  {
    "code": "TL",
    "name": "Timor-Leste",
    "nameAr": "تيمور الشرقية",
    "nameFr": "Timor-Leste",
    "cities": [
      {
        "name": "Aileu",
        "nameAr": "",
        "nameFr": "Aileu"
      },
      {
        "name": "Ainaro",
        "nameAr": "",
        "nameFr": "Ainaro"
      },
      {
        "name": "Baucau",
        "nameAr": "",
        "nameFr": "Baucau"
      },
      {
        "name": "Bobonaro",
        "nameAr": "",
        "nameFr": "Bobonaro"
      },
      {
        "name": "Cova Lima",
        "nameAr": "",
        "nameFr": "Cova Lima"
      },
      {
        "name": "Dili",
        "nameAr": "",
        "nameFr": "Dili"
      },
      {
        "name": "Ermera",
        "nameAr": "",
        "nameFr": "Ermera"
      },
      {
        "name": "Lautém",
        "nameAr": "",
        "nameFr": "Lautém"
      },
      {
        "name": "Liquiçá",
        "nameAr": "",
        "nameFr": "Liquiçá"
      },
      {
        "name": "Manatuto",
        "nameAr": "",
        "nameFr": "Manatuto"
      },
      {
        "name": "Manufahi",
        "nameAr": "",
        "nameFr": "Manufahi"
      },
      {
        "name": "Viqueque",
        "nameAr": "",
        "nameFr": "Viqueque"
      }
    ]
  },
  {
    "code": "TR",
    "name": "Turkey",
    "nameAr": "تركيا",
    "nameFr": "Turkey",
    "cities": [
            {
                  "name": "Adana",
                  "nameAr": "Adana",
                  "nameFr": "Adana"
            },
            {
                  "name": "Adıyaman",
                  "nameAr": "Adıyaman",
                  "nameFr": "Adıyaman"
            },
            {
                  "name": "Afyonkarahisar",
                  "nameAr": "Afyonkarahisar",
                  "nameFr": "Afyonkarahisar"
            },
            {
                  "name": "Ağrı",
                  "nameAr": "Ağrı",
                  "nameFr": "Ağrı"
            },
            {
                  "name": "Aksaray",
                  "nameAr": "Aksaray",
                  "nameFr": "Aksaray"
            },
            {
                  "name": "Amasya",
                  "nameAr": "Amasya",
                  "nameFr": "Amasya"
            },
            {
                  "name": "Ankara",
                  "nameAr": "Ankara",
                  "nameFr": "Ankara"
            },
            {
                  "name": "Antalya",
                  "nameAr": "Antalya",
                  "nameFr": "Antalya"
            },
            {
                  "name": "Ardahan",
                  "nameAr": "Ardahan",
                  "nameFr": "Ardahan"
            },
            {
                  "name": "Artvin",
                  "nameAr": "Artvin",
                  "nameFr": "Artvin"
            },
            {
                  "name": "Aydın",
                  "nameAr": "Aydın",
                  "nameFr": "Aydın"
            },
            {
                  "name": "Balıkesir",
                  "nameAr": "Balıkesir",
                  "nameFr": "Balıkesir"
            },
            {
                  "name": "Bartın",
                  "nameAr": "Bartın",
                  "nameFr": "Bartın"
            },
            {
                  "name": "Batman",
                  "nameAr": "Batman",
                  "nameFr": "Batman"
            },
            {
                  "name": "Bayburt",
                  "nameAr": "Bayburt",
                  "nameFr": "Bayburt"
            },
            {
                  "name": "Bilecik",
                  "nameAr": "Bilecik",
                  "nameFr": "Bilecik"
            },
            {
                  "name": "Bingöl",
                  "nameAr": "Bingöl",
                  "nameFr": "Bingöl"
            },
            {
                  "name": "Bitlis",
                  "nameAr": "Bitlis",
                  "nameFr": "Bitlis"
            },
            {
                  "name": "Bolu",
                  "nameAr": "Bolu",
                  "nameFr": "Bolu"
            },
            {
                  "name": "Burdur",
                  "nameAr": "Burdur",
                  "nameFr": "Burdur"
            },
            {
                  "name": "Bursa",
                  "nameAr": "Bursa",
                  "nameFr": "Bursa"
            },
            {
                  "name": "Çanakkale",
                  "nameAr": "Çanakkale",
                  "nameFr": "Çanakkale"
            },
            {
                  "name": "Çankırı",
                  "nameAr": "Çankırı",
                  "nameFr": "Çankırı"
            },
            {
                  "name": "Çorum",
                  "nameAr": "Çorum",
                  "nameFr": "Çorum"
            },
            {
                  "name": "Denizli",
                  "nameAr": "Denizli",
                  "nameFr": "Denizli"
            },
            {
                  "name": "Diyarbakır",
                  "nameAr": "Diyarbakır",
                  "nameFr": "Diyarbakır"
            },
            {
                  "name": "Düzce",
                  "nameAr": "Düzce",
                  "nameFr": "Düzce"
            },
            {
                  "name": "Edirne",
                  "nameAr": "Edirne",
                  "nameFr": "Edirne"
            },
            {
                  "name": "Elazığ",
                  "nameAr": "Elazığ",
                  "nameFr": "Elazığ"
            },
            {
                  "name": "Erzincan",
                  "nameAr": "Erzincan",
                  "nameFr": "Erzincan"
            },
            {
                  "name": "Erzurum",
                  "nameAr": "Erzurum",
                  "nameFr": "Erzurum"
            },
            {
                  "name": "Eskişehir",
                  "nameAr": "Eskişehir",
                  "nameFr": "Eskişehir"
            },
            {
                  "name": "Gaziantep",
                  "nameAr": "Gaziantep",
                  "nameFr": "Gaziantep"
            },
            {
                  "name": "Giresun",
                  "nameAr": "Giresun",
                  "nameFr": "Giresun"
            },
            {
                  "name": "Gümüşhane",
                  "nameAr": "Gümüşhane",
                  "nameFr": "Gümüşhane"
            },
            {
                  "name": "Hakkâri",
                  "nameAr": "Hakkâri",
                  "nameFr": "Hakkâri"
            },
            {
                  "name": "Hatay",
                  "nameAr": "Hatay",
                  "nameFr": "Hatay"
            },
            {
                  "name": "Iğdır",
                  "nameAr": "Iğdır",
                  "nameFr": "Iğdır"
            },
            {
                  "name": "Isparta",
                  "nameAr": "Isparta",
                  "nameFr": "Isparta"
            },
            {
                  "name": "İstanbul",
                  "nameAr": "İstanbul",
                  "nameFr": "İstanbul"
            },
            {
                  "name": "İzmir",
                  "nameAr": "İzmir",
                  "nameFr": "İzmir"
            },
            {
                  "name": "Kahramanmaraş",
                  "nameAr": "Kahramanmaraş",
                  "nameFr": "Kahramanmaraş"
            },
            {
                  "name": "Karabük",
                  "nameAr": "Karabük",
                  "nameFr": "Karabük"
            },
            {
                  "name": "Karaman",
                  "nameAr": "Karaman",
                  "nameFr": "Karaman"
            },
            {
                  "name": "Kars",
                  "nameAr": "Karma",
                  "nameFr": "Kars"
            },
            {
                  "name": "Kastamonu",
                  "nameAr": "Kastamonu",
                  "nameFr": "Kastamonu"
            },
            {
                  "name": "Kayseri",
                  "nameAr": "Kayseri",
                  "nameFr": "Kayseri"
            },
            {
                  "name": "Kilis",
                  "nameAr": "Kilis",
                  "nameFr": "Kilis"
            },
            {
                  "name": "Kırıkkale",
                  "nameAr": "Kırıkkale",
                  "nameFr": "Kırıkkale"
            },
            {
                  "name": "Kırklareli",
                  "nameAr": "Kırklareli",
                  "nameFr": "Kırklareli"
            },
            {
                  "name": "Kırşehir",
                  "nameAr": "Kırşehir",
                  "nameFr": "Kırşehir"
            },
            {
                  "name": "Kocaeli",
                  "nameAr": "Kocaeli",
                  "nameFr": "Kocaeli"
            },
            {
                  "name": "Konya",
                  "nameAr": "Konya",
                  "nameFr": "Konya"
            },
            {
                  "name": "Kütahya",
                  "nameAr": "Kütahya",
                  "nameFr": "Kütahya"
            },
            {
                  "name": "Malatya",
                  "nameAr": "Malatya",
                  "nameFr": "Malatya"
            },
            {
                  "name": "Manisa",
                  "nameAr": "Manisa",
                  "nameFr": "Manisa"
            },
            {
                  "name": "Mardin",
                  "nameAr": "Mardin",
                  "nameFr": "Mardin"
            },
            {
                  "name": "Mersin",
                  "nameAr": "Mersin",
                  "nameFr": "Mersin"
            },
            {
                  "name": "Muğla",
                  "nameAr": "Muğla",
                  "nameFr": "Muğla"
            },
            {
                  "name": "Muş",
                  "nameAr": "Muş",
                  "nameFr": "Muş"
            },
            {
                  "name": "Nevşehir",
                  "nameAr": "Nevşehir",
                  "nameFr": "Nevşehir"
            },
            {
                  "name": "Niğde",
                  "nameAr": "Niğde",
                  "nameFr": "Niğde"
            },
            {
                  "name": "Ordu",
                  "nameAr": "Saat",
                  "nameFr": "Ordu"
            },
            {
                  "name": "Osmaniye",
                  "nameAr": "Osmaniye",
                  "nameFr": "Osmaniye"
            },
            {
                  "name": "Rize",
                  "nameAr": "Rize",
                  "nameFr": "Rize"
            },
            {
                  "name": "Sakarya",
                  "nameAr": "Sakarya",
                  "nameFr": "Sakarya"
            },
            {
                  "name": "Samsun",
                  "nameAr": "Samsun",
                  "nameFr": "Samsun"
            },
            {
                  "name": "Şanlıurfa",
                  "nameAr": "Şanlıurfa",
                  "nameFr": "Şanlıurfa"
            },
            {
                  "name": "Siirt",
                  "nameAr": "Siirt",
                  "nameFr": "Siirt"
            },
            {
                  "name": "Sinop",
                  "nameAr": "Sinop",
                  "nameFr": "Sinop"
            },
            {
                  "name": "Sivas",
                  "nameAr": "Sivas",
                  "nameFr": "Sivas"
            },
            {
                  "name": "Şırnak",
                  "nameAr": "Şırnak",
                  "nameFr": "Şırnak"
            },
            {
                  "name": "Tekirdağ",
                  "nameAr": "Tekirdağ",
                  "nameFr": "Tekirdağ"
            },
            {
                  "name": "Tokat",
                  "nameAr": "Tokat",
                  "nameFr": "Tokat"
            },
            {
                  "name": "Trabzon",
                  "nameAr": "Trabzon",
                  "nameFr": "Trabzon"
            },
            {
                  "name": "Tunceli",
                  "nameAr": "Tunceli",
                  "nameFr": "Tunceli"
            },
            {
                  "name": "Uşak",
                  "nameAr": "Uşak",
                  "nameFr": "Uşak"
            },
            {
                  "name": "Van",
                  "nameAr": "Minibüs",
                  "nameFr": "Van"
            },
            {
                  "name": "Yalova",
                  "nameAr": "Yalova",
                  "nameFr": "Yalova"
            },
            {
                  "name": "Yozgat",
                  "nameAr": "Yozgat",
                  "nameFr": "Yozgat"
            },
            {
                  "name": "Zonguldak",
                  "nameAr": "Zonguldak",
                  "nameFr": "Zonguldak"
            }
      ]
  },
  {
    "code": "TM",
    "name": "Turkmenistan",
    "nameAr": "تركمانستان",
    "nameFr": "Turkmenistan",
    "cities": [
            {
                  "name": "Ahal",
                  "nameAr": "Mümkin",
                  "nameFr": "Ahal"
            },
            {
                  "name": "Ashgabat",
                  "nameAr": "Ashgabat",
                  "nameFr": "Ashgabat"
            },
            {
                  "name": "Balkan",
                  "nameAr": "Balkan",
                  "nameFr": "Balkan"
            },
            {
                  "name": "Daşoguz",
                  "nameAr": "Daş",
                  "nameFr": "Daşoguz"
            },
            {
                  "name": "Lebap",
                  "nameAr": "Lebap",
                  "nameFr": "Lebap"
            },
            {
                  "name": "Mary",
                  "nameAr": "Mary",
                  "nameFr": "Mary"
            }
      ]
  },
  {
    "code": "AE",
    "name": "United Arab Emirates",
    "nameAr": "الإمارات العربية المتحدة",
    "nameFr": "United Arab Emirates",
    "cities": [
            {
                  "name": "Fujairah",
                  "nameAr": "الفجيرة",
                  "nameFr": "Fujairah"
            },
            {
                  "name": "Abu Dhabi",
                  "nameAr": "أبو ظبي",
                  "nameFr": "Abu Dhabi"
            },
            {
                  "name": "Dubai",
                  "nameAr": "دبي",
                  "nameFr": "Dubai"
            },
            {
                  "name": "Ras Al Khaimah",
                  "nameAr": "رأس الخيمة",
                  "nameFr": "Ras Al Khaimah"
            },
            {
                  "name": "Umm Al Quwain",
                  "nameAr": "أم القيوين",
                  "nameFr": "Umm Al Quwain"
            },
            {
                  "name": "Sharjah",
                  "nameAr": "الشارقة",
                  "nameFr": "Sharjah"
            },
            {
                  "name": "Ajman",
                  "nameAr": "عجمان",
                  "nameFr": "Ajman"
            }
      ]
  },
  {
    "code": "UZ",
    "name": "Uzbekistan",
    "nameAr": "أوزبكستان",
    "nameFr": "Uzbekistan",
    "cities": [
            {
                  "name": "Andijan",
                  "nameAr": "Andijan",
                  "nameFr": "Andijan"
            },
            {
                  "name": "Bukhara",
                  "nameAr": "Buxoro",
                  "nameFr": "Bukhara"
            },
            {
                  "name": "Fergana",
                  "nameAr": "Farg'ona",
                  "nameFr": "Fergana"
            },
            {
                  "name": "Jizzakh",
                  "nameAr": "Jizzakh",
                  "nameFr": "Jizzakh"
            },
            {
                  "name": "Karakalpakstan",
                  "nameAr": "Qoraqalpog'iston",
                  "nameFr": "Karakalpakstan"
            },
            {
                  "name": "Namangan",
                  "nameAr": "Namangan",
                  "nameFr": "Namangan"
            },
            {
                  "name": "Navoiy",
                  "nameAr": "Navoiy",
                  "nameFr": "Navoiy"
            },
            {
                  "name": "Qashqadaryo",
                  "nameAr": "Qashqadaryo",
                  "nameFr": "Qashqadaryo"
            },
            {
                  "name": "Samarqand",
                  "nameAr": "Samarqand",
                  "nameFr": "Samarqand"
            },
            {
                  "name": "Sirdaryo",
                  "nameAr": "Sirdaryo",
                  "nameFr": "Sirdaryo"
            },
            {
                  "name": "Surxondaryo",
                  "nameAr": "Surxondaryo",
                  "nameFr": "Surxondaryo"
            },
            {
                  "name": "Tashkent",
                  "nameAr": "Tashkent",
                  "nameFr": "Tashkent"
            },
            {
                  "name": "Tashkent",
                  "nameAr": "Toshkent",
                  "nameFr": "Tashkent"
            },
            {
                  "name": "Xorazm",
                  "nameAr": "Xorazm",
                  "nameFr": "Xorazm"
            }
      ]
  },
  {
    "code": "VN",
    "name": "Vietnam",
    "nameAr": "فيتنام",
    "nameFr": "Vietnam",
    "cities": [
            {
                  "name": "An Giang",
                  "nameAr": "An Giang",
                  "nameFr": "An Giang"
            },
            {
                  "name": "Bắc Ninh",
                  "nameAr": "Bắc Ninh",
                  "nameFr": "Bắc Ninh"
            },
            {
                  "name": "Cà Mau",
                  "nameAr": "Cà Mau",
                  "nameFr": "Cà Mau"
            },
            {
                  "name": "Cần Thơ",
                  "nameAr": "Cần Thơ",
                  "nameFr": "Cần Thơ"
            },
            {
                  "name": "Cao Bằng",
                  "nameAr": "Cao Bằng",
                  "nameFr": "Cao Bằng"
            },
            {
                  "name": "Đà Nẵng",
                  "nameAr": "Đà Nẵng",
                  "nameFr": "Đà Nẵng"
            },
            {
                  "name": "Đắk Lắk",
                  "nameAr": "Đắk Lắk",
                  "nameFr": "Đắk Lắk"
            },
            {
                  "name": "Điện Biên",
                  "nameAr": "Điện Biên",
                  "nameFr": "Điện Biên"
            },
            {
                  "name": "Đồng Nai",
                  "nameAr": "Đồng Nai",
                  "nameFr": "Đồng Nai"
            },
            {
                  "name": "Đồng Tháp",
                  "nameAr": "Đồng Tháp",
                  "nameFr": "Đồng Tháp"
            },
            {
                  "name": "Gia Lai",
                  "nameAr": "Gia Lai",
                  "nameFr": "Gia Lai"
            },
            {
                  "name": "Hà Nội",
                  "nameAr": "Hà Nội",
                  "nameFr": "Hà Nội"
            },
            {
                  "name": "Hà Tĩnh",
                  "nameAr": "Hà Tĩnh",
                  "nameFr": "Hà Tĩnh"
            },
            {
                  "name": "Hải Phòng",
                  "nameAr": "Hải Phòng",
                  "nameFr": "Hải Phòng"
            },
            {
                  "name": "Hồ Chí Minh",
                  "nameAr": "Hồ Chí Minh",
                  "nameFr": "Hồ Chí Minh"
            },
            {
                  "name": "Hưng Yên",
                  "nameAr": "Hưng Yên",
                  "nameFr": "Hưng Yên"
            },
            {
                  "name": "Khánh Hòa",
                  "nameAr": "Khánh Hòa",
                  "nameFr": "Khánh Hòa"
            },
            {
                  "name": "Lai Châu",
                  "nameAr": "Lai Châu",
                  "nameFr": "Lai Châu"
            },
            {
                  "name": "Lâm Đồng",
                  "nameAr": "Lâm Đồng",
                  "nameFr": "Lâm Đồng"
            },
            {
                  "name": "Lạng Sơn",
                  "nameAr": "Lạng Sơn",
                  "nameFr": "Lạng Sơn"
            },
            {
                  "name": "Lào Cai",
                  "nameAr": "Lào Cai",
                  "nameFr": "Lào Cai"
            },
            {
                  "name": "Nghệ An",
                  "nameAr": "Nghệ An",
                  "nameFr": "Nghệ An"
            },
            {
                  "name": "Ninh Bình",
                  "nameAr": "Ninh Bình",
                  "nameFr": "Ninh Bình"
            },
            {
                  "name": "Phú Thọ",
                  "nameAr": "Phú Thọ",
                  "nameFr": "Phú Thọ"
            },
            {
                  "name": "Quảng Ngãi",
                  "nameAr": "Quảng Ngãi",
                  "nameFr": "Quảng Ngãi"
            },
            {
                  "name": "Quảng Ninh",
                  "nameAr": "Quảng Ninh",
                  "nameFr": "Quảng Ninh"
            },
            {
                  "name": "Quảng Trị",
                  "nameAr": "Quảng Trị",
                  "nameFr": "Quảng Trị"
            },
            {
                  "name": "Sơn La",
                  "nameAr": "Sơn La",
                  "nameFr": "Sơn La"
            },
            {
                  "name": "Tây Ninh",
                  "nameAr": "Tây Ninh",
                  "nameFr": "Tây Ninh"
            },
            {
                  "name": "Thái Nguyên",
                  "nameAr": "Thái Nguyên",
                  "nameFr": "Thái Nguyên"
            },
            {
                  "name": "Thanh Hóa",
                  "nameAr": "Thanh Hóa",
                  "nameFr": "Thanh Hóa"
            },
            {
                  "name": "Thừa Thiên-Huế",
                  "nameAr": "Thừa Thiên-Huế",
                  "nameFr": "Thừa Thiên-Huế"
            },
            {
                  "name": "Tuyên Quang",
                  "nameAr": "Tuyên Quang",
                  "nameFr": "Tuyên Quang"
            },
            {
                  "name": "Vĩnh Long",
                  "nameAr": "Vĩnh Long",
                  "nameFr": "Vĩnh Long"
            }
      ]
  },
  {
    "code": "YE",
    "name": "Yemen",
    "nameAr": "اليمن",
    "nameFr": "Yemen",
    "cities": [
            {
                  "name": "Sana'a",
                  "nameAr": "صنعاء",
                  "nameFr": "Sanaa"
            },
            {
                  "name": "Aden",
                  "nameAr": "عدن",
                  "nameFr": "Aden"
            },
            {
                  "name": "Ta'izz",
                  "nameAr": "تعز",
                  "nameFr": "Taez"
            },
            {
                  "name": "Hodeidah",
                  "nameAr": "الحديدة",
                  "nameFr": "Hodeida"
            },
            {
                  "name": "Ibb",
                  "nameAr": "إب",
                  "nameFr": "Ibb"
            },
            {
                  "name": "Dhamar",
                  "nameAr": "ذمار",
                  "nameFr": "Dhamar"
            },
            {
                  "name": "Hajjah",
                  "nameAr": "حجة",
                  "nameFr": "Hajjah"
            },
            {
                  "name": "Saada",
                  "nameAr": "صعدة",
                  "nameFr": "Saada"
            },
            {
                  "name": "Amran",
                  "nameAr": "عمران",
                  "nameFr": "Amran"
            },
            {
                  "name": "Al Mahwit",
                  "nameAr": "المحويت",
                  "nameFr": "Al Mahwit"
            },
            {
                  "name": "Raymah",
                  "nameAr": "ريمة",
                  "nameFr": "Raymah"
            },
            {
                  "name": "Hadhramaut",
                  "nameAr": "حضرموت",
                  "nameFr": "Hadramaout"
            },
            {
                  "name": "Al Mahrah",
                  "nameAr": "المهرة",
                  "nameFr": "Al Mahrah"
            },
            {
                  "name": "Shabwah",
                  "nameAr": "شبوة",
                  "nameFr": "Shabwah"
            },
            {
                  "name": "Abyan",
                  "nameAr": "أبين",
                  "nameFr": "Abyan"
            },
            {
                  "name": "Lahij",
                  "nameAr": "لحج",
                  "nameFr": "Lahij"
            },
            {
                  "name": "Al Bayda",
                  "nameAr": "البيضاء",
                  "nameFr": "Al Bayda"
            },
            {
                  "name": "Al Jawf",
                  "nameAr": "الجوف",
                  "nameFr": "Al Jawf"
            },
            {
                  "name": "Marib",
                  "nameAr": "مأرب",
                  "nameFr": "Marib"
            },
            {
                  "name": "Socotra",
                  "nameAr": "سقطرى",
                  "nameFr": "Socotra"
            },
            {
                  "name": "Amanat Al Asimah",
                  "nameAr": "أمانة العاصمة",
                  "nameFr": "Amanat Al Asimah"
            }
      ]
  }
];
